import {useEffect, useState, useRef} from "react";
import {db} from "../db";
import {getApiBaseUrl} from "../api-helper";
import useIsMobile from "../hooks/useIsMobile";
import { ReactComponent as CardAdd } from '../images/icons/image-card-icons/card-icon-add-to-collection.svg';
import { ReactComponent as CardInCollection } from '../images/icons/image-card-icons/card-icon-add-to-collection-active.svg';
import { ReactComponent as CardRemove } from '../images/icons/image-card-icons/card-icon-remove.svg';
import { ReactComponent as CardCopy } from '../images/icons/image-card-icons/card-icon-copy-image.svg';
import { ReactComponent as CardCopyDescription } from '../images/icons/image-card-icons/card-icon-copy-description.svg';
import { ReactComponent as CardSave } from '../images/icons/image-card-icons/card-icon-save-image.svg';
import { ReactComponent as CardSaveDescription}  from '../images/icons/image-card-icons/card-icon-save-description.svg';
import { ReactComponent as CardPopulatePrompt } from '../images/icons/image-card-icons/card-icon-populate-prompt.svg';
import { ReactComponent as CardZoom } from '../images/icons/image-card-icons/card-icon-zoom-in.svg';
import { ReactComponent as CardShare } from '../images/icons/image-card-icons/card-icon-share-to-community.svg';
import { ReactComponent as CardTag } from '../images/icons/image-card-icons/card-icon-tag.svg';
import { ReactComponent as CardPublic }  from '../images/icons/image-card-icons/card-icon-public.svg';
import { ReactComponent as CardPrivate }  from '../images/icons/image-card-icons/card-icon-private.svg';
import { ReactComponent as CardEye } from '../images/icons/image-card-icons/card-icon-eye.svg';
import { ReactComponent as CardImageDescribe } from '../images/icons/image-card-icons/card-icon-describe-image.svg';
import { ReactComponent as CardEdit } from '../images/icons/image-card-icons/card-icon-edit.svg'
import { ReactComponent as CardPaste } from "../images/icons/image-card-icons/card-icon-paste.svg"
import { ReactComponent as CloseIcon } from "../images/icons/white-close.svg";
import { ReactComponent as UploadIconWhite } from "../images/icons/input-bar-icons/icon-input-bar-upload-white.svg";
import Image from "image-js";
import CollectSound from "../sounds/collect.flac";
import { useDriverContext, useDriverContextDispatch } from "../context/DriverContext";
import { useCollectionContext, useCollectionContextDispatch } from "../context/CollectionContext";
import { useAccountContext } from "../context/AccountContext";
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';
import Select, {InputAction} from 'react-select';
import makeAnimated from 'react-select/animated'
import { isUndefined } from "cropperjs";
import Swal from "sweetalert2";
import ToggleInput from "./inputs/ToggleInput";
import {
    changeImageVisibility,
    deleteCollectionImage,
    getImageDescription, getImageMetadata, getPromptFileData,
    updateAccount,
    updateImageTags,
    shareImage, shareToSocialMedia,
    getProgress,
    getGenerateOutput,
    setReceived,
    getAuthorizationToken,
    getUseDepApi
} from "../api-helper";
import { useNavigate } from "react-router-dom";
import { useGenerateDispatch, useGenerateStatus } from "../context/GenerateContext";
//import { useGenerateStatus } from "../context/GenerateContext";
import { usePromptContext } from '../context/PromptContext';
import { copyDescriptionToClipboard, downloadDescriptionAsPromptFile, populatePromptField } from './ImageDescriptionUtils';
import { memo } from "react";
import FullImageViewer from "./FullImageViewer";

import {
    EmailIcon,
    EmailShareButton, FacebookIcon,
    FacebookShareButton, LinkedinIcon,
    LinkedinShareButton,
    TwitterIcon,
    TwitterShareButton, WhatsappIcon,
    WhatsappShareButton, XIcon
} from "react-share";
import { usePromptusAPIState } from "../context/PromptusAPIContext";
import electronBridge from '../utils/electronBridge';
import eventBus from '../utils/eventBus';
import { fetchMediaType, getImageDimensions } from "../utils/MediaOperations";

// MoMM Chat Icon Component for Send to MoMM functionality
const MOMMIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
  </svg>
);

const animatedComponents = makeAnimated()

export async function downloadString(text, fileType, fileName) {
    const blob = new Blob([text], { type: fileType });
    const ext = fileName.split('.').pop();

    if (window.showSaveFilePicker && !electronBridge.isElectron) {
        try {
            const handle = await window.showSaveFilePicker({
                suggestedName: fileName,
                types: [{ description: `${ext.toUpperCase()} File`, accept: { [fileType]: [`.${ext}`] } }]
            });
            const writable = await handle.createWritable();
            await writable.write(blob);
            await writable.close();
            return;
        } catch (err) {
            if (err.name === 'AbortError') return;
            console.warn('showSaveFilePicker failed, falling back:', err);
        }
    } 

    const a = document.createElement('a');
    a.download = fileName;
    a.href = URL.createObjectURL(blob);
    a.dataset.downloadurl = [fileType, a.download, a.href].join(':');
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(function() { URL.revokeObjectURL(a.href); }, 1500);
}

const CollectionImage = memo((props) => {
    const [promptInfo, setPromptInfo] = useState({});
    const [showSaveDialog, setShowSaveDialog] = useState(false);
    // const [showShareDialog, setShowShareDialog] = useState(false);
    const [privateImage, setPrivateImage] = useState(true);
    const [dimensions, setDimensions] = useState('0 x 0');
    const [visibility, setVisibility] = useState("");
    const [downloadName, setDownloadName] = useState(`Promptus_${props.uid}`)
    const [showMobileToolbar, setShowMobileToolbar] = useState(false);
    const isMobile = useIsMobile();
    const toolbarRef = useRef(null);
    const menuButtonRef = useRef(null);
    const [tags, setTags] = useState([]);
    const driverContextDispatch = useDriverContextDispatch();
    const collectionContextDispatch = useCollectionContextDispatch();
    const collectionContext = useCollectionContext();
    const accountContext = useAccountContext();
    const apiState = usePromptusAPIState();
    const [open, setOpen] = useState(false);
    const [openDescribeImage, setOpenDescribeImage] = useState(false);
    const [openShare, setShare] = useState(false);
    const [tag, setTag] = useState("");
    const [multiTag, setMultiTag] = useState("");
    const [options, setOptions] = useState([]); 
    const [inputTag, setInputTag] = useState("");
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [clearTags, setClearTags] = useState(false);
    const [tagLoading, setTagLoading] = useState(false);
    const [failedImage, setFailedImage] = useState(false);
    const [imageRegenerating, setImageRegenerating] = useState(false);
    const [imageLoadError, setImageLoadError] = useState(false);
    const [imageLoading, setImageLoading] = useState(true);
    const [retryCount, setRetryCount] = useState(0);
    const [hasImageField, setHasImageField] = useState(false); // Default to false (hide button), will be set to true by schema event if image fields exist
    const [currentSchema, setCurrentSchema] = useState({}); // Track current schema for useImage logic
    const [workloadRegenerating, setWorkloadRegenerating] = useState(false);
    const [workloadUidRegenerating, setWorkloadUidRegenerating] = useState("");
    const [imageIDRegenerating, setImageIDRegenerating] = useState(0);
    const [regenLogic, setRegenLogic] = useState(false);
    const [imageDescription, setImageDescription] = useState("");
    const navigate = useNavigate();
    const generateStatus = useGenerateStatus();
    const generateStatusDispatch = useGenerateDispatch();
    const { updatePrompt } = usePromptContext();
    const [clipboardMessage, setClipboardMessage] = useState('');    
    const [shareUrl, setShareUrl] = useState('');
    const [imageDescriptionLoading, setImageDescriptionLoading] = useState(false);
    const [localInCollection, setLocalInCollection] = useState(props.inCollection);
    const [showShareImageDialog, setshowShareImageDialog] = useState(false)
    const [zoomedImage, setZoomedImage] = useState(null)
    const [imageClicked, setImageClicked] = useState(false);
    const [isSmallImage, setIsSmallImage] = useState(false);
    const [imageRef, setImageRef] = useState(null);
    const [localDirectory, setLocalDirectory] = useState("");
    const [localImageOverride, setLocalImageOverride] = useState(null);

    useEffect(() => {
        setPromptInfo({prompt: props.prompt})

        if (props.public && props.public == "1") {
            setVisibility("Public");
            setPrivateImage(false);
        } else {
            setVisibility("Private")
            setPrivateImage(true);
        }
        setTag(props.tag || "");

        if (!props.image || props.image === '' || generateStatus.failedImage || isUndefined(props.image)) {
            setFailedImage(true);
        } else {
            setFailedImage(false);
        }

        if (generateStatus.failedImageID !== null) {
            setImageIDRegenerating(generateStatus.failedImageID);
        }
    }, [props.uid]);

    useEffect(() => {
        const convertBase64ToUrl = async () => {
            if (electronBridge.isElectron) {
                return;
            }

            const isImageUrl = props.image && (props.image.startsWith('http://') || props.image.startsWith('https://'));

            if (!isImageUrl && props.uid && props.hash && props.image) {
                try {
                    console.log('[CollectionImage] Base64 image detected, fetching URL from API...');
                    const result = await getGenerateOutput(props.uid, props.hash);
                    console.log('[CollectionImage] Response from API:', result);

                    if (result.url && result.url.trim() !== '') {
                        console.log('[CollectionImage] Successfully retrieved URL from API:', result.url);

                        await db.images.where('hash').equals(props.hash).modify({ image: result.url });
                        await db.collectedImages.where('hash').equals(props.hash).modify({ image: result.url });

                        setLocalImageOverride(result.url);
                    }
                } catch (error) {
                    console.error('[CollectionImage] Error fetching URL from API:', error);
                }
            }
        };

        convertBase64ToUrl();
    }, [props.image, props.uid, props.hash]);

    async function getMediaType(base64String, returnExtension = false) {
        try {
            const cleaned = base64String.trim().replace(/\s/g, '');
            const padded = cleaned + '==='.slice((cleaned.length + 3) % 4);
            const binaryStr = atob(padded);
            const bytes = new Uint8Array(binaryStr.length);

            for (let i = 0; i < binaryStr.length; i++) {
                bytes[i] = binaryStr.charCodeAt(i);
            }

            // Generate hex string from first 64 bytes for better detection
            const hex = Array.from(bytes.slice(0, 64))
                .map(b => b.toString(16).padStart(2, '0'))
                .join('');

            console.log('First 64 bytes hex:', hex);

            // Helper to check ASCII string at offset
            const asciiAt = (offset, str) => {
                if (offset + str.length > bytes.length) return false;
                for (let i = 0; i < str.length; i++) {
                    if (bytes[offset + i] !== str.charCodeAt(i)) return false;
                }
                return true;
            };

            // RIFF-based formats need special handling (WAV, WEBP, AVI all start with RIFF)
            if (hex.startsWith('52494646') && bytes.length >= 12) {
                if (asciiAt(8, 'WAVE')) return returnExtension ? 'wav' : "Audio";
                if (asciiAt(8, 'WEBP')) return returnExtension ? 'webp' : "Image";
                if (asciiAt(8, 'AVI ')) return returnExtension ? 'avi' : "Video";
            }

            // MP3: ID3 tag or frame sync
            if (asciiAt(0, 'ID3') || (bytes[0] === 0xFF && (bytes[1] & 0xE0) === 0xE0)) {
                return returnExtension ? 'mp3' : "Audio";
            }

            // FLAC: starts with "fLaC"
            if (asciiAt(0, 'fLaC')) {
                return returnExtension ? 'flac' : "Audio";
            }

            // M4A/MP4: ftyp with brands
            if (bytes.length >= 12 && bytes[4] === 0x66 && bytes[5] === 0x74 && bytes[6] === 0x79 && bytes[7] === 0x70) {
                const brand = String.fromCharCode(bytes[8], bytes[9], bytes[10], bytes[11]);
                if (brand === 'M4A ' || brand === 'M4B ') {
                    return returnExtension ? 'm4a' : "Audio";
                }
                return returnExtension ? 'mp4' : "Video";
            }

            // Other signatures
            const signatures = [
                { type: 'image/png', hex: '89504e47', ext: 'png' },
                { type: 'image/jpeg', hex: 'ffd8ff', ext: 'jpg' },
                { type: 'video/webm', hex: '1a45dfa3', ext: 'webm' },
                { type: 'audio/ogg', hex: '4f676753', ext: 'ogg' },
                { type: 'application/pdf', hex: '25504446', ext: 'pdf' },
            ];

            const matched = signatures.find(sig => hex.startsWith(sig.hex.toLowerCase()));
            if (matched) {
                if (returnExtension) return matched.ext;
                const mimeType = matched.type;
                if (mimeType.startsWith("image/")) return "Image";
                if (mimeType.startsWith("video/")) return "Video";
                if (mimeType.startsWith("audio/")) return "Audio";
                return mimeType;
            }

            console.log(`getMediaType: Unknown media type, hex: ${hex.substring(0, 32)}`);
            return returnExtension ? 'unknown' : "Unknown";
        } catch (err) {
            console.error("Error parsing base64:", err);
            return returnExtension ? 'invalid' : "Invalid Base64 String";
        }
    }

    // Function to check if image container is small
    const checkImageSize = () => {
        if (imageRef) {
            const rect = imageRef.getBoundingClientRect();
            const isSmall = rect.width < 200; // Consider images smaller than 200px as small
            setIsSmallImage(isSmall);
        }
    };

    // Effect to check image size on load and resize
    useEffect(() => {
        if (imageRef) {
            checkImageSize();
            // Also check on window resize
            window.addEventListener('resize', checkImageSize);
            return () => window.removeEventListener('resize', checkImageSize);
        }
    }, [imageRef]);

    // Listen for schema updates to determine if useImage button should be shown
    useEffect(() => {
        const handleSchemaUpdate = (schemaInfo) => {
            const fieldTypes = Object.entries(schemaInfo.schema || {}).map(([key, field]) => `${key}:${field.type}`);
            console.log('[CollectionImage] Received schema update:', { hasImageField: schemaInfo.hasImageField, fieldTypes });
            setHasImageField(schemaInfo.hasImageField);
            setCurrentSchema(schemaInfo.schema || {});
        };
        
        eventBus.on('schemaUpdate', handleSchemaUpdate);

        // Request current schema on mount in case it was emitted before this component mounted
        eventBus.emit('requestSchema');

        return () => eventBus.off('schemaUpdate', handleSchemaUpdate);
    }, []);

    // Effect to check size when image loads
    useEffect(() => {
        if (imageRef) {
            const img = imageRef.querySelector('img');
            if (img) {
                img.onload = checkImageSize;
            }
        }
    }, [imageRef]);

    /**
     * Tries to grab the collection image with the given uid
     * @returns {Promise<*>}
     */
    const getSpecificImage = async (uid) => {
        return await db.collection
            .where('uid')
            .equals(uid)
            .first();
    }

    const toggleCollection = async () => {
        if (accountContext.loggedIn === false) {
            Swal.fire({
                title: "Not Logged In",
                text: "You need to be logged in to add images to your collection. Please login to your account to proceed.",
                icon: "error",
                confirmButtonText: "Ok",
                confirmButtonColor: "#FFB02E",
            }).then((result) => {
                if (result.isConfirmed) {
                    navigate('/profile')
                }
            })
            return;          
        }

        // Set the toggle lock
        await db.settings.put({ key: 'toggleLock', value: true });

        // Pre-loading Sound File and setting check
        const collectAudio = new Audio(CollectSound);
        const soundSettingCheck = await db.settings.where('key').equals('play_sounds').first()
        console.log(props);
        
        try{
        const inCollection = !props.inCollection;

        let inPlayground = false;
        let propsId = props.id;
        const images = await db.images.where('image').equals(props.image).toArray();
        if (images.length > 0) {
            propsId = images[0].id;
            inPlayground = true;
        }

        if (propsId !== undefined && propsId !== null && (typeof propsId === 'string' || typeof propsId === 'number')) {
            await db.images
                .update(propsId, {inCollection})
                .then(async () => {
                    await db.collectedImages.where('image').equals(props.image).count(async(imageCount) => {
                        if (imageCount > 0) {
                            // removing the image from the collection
                            if (!inCollection) {
                                if (!inPlayground) {
                                    await db.collectedImages.where('image').equals(props.image).toArray(async(collectedImage) => {
                                        if (collectedImage.length > 0) {
                                            console.log("Adding image to playground");
                                            // THIS SHOULD BE IN THE SAME FORMAT AS getPromptFileData
                                            await getImageMetadata(accountContext.accountDetails.accountNo, collectedImage[0].hash)
                                                .then((prompt) => {
                                                    db.collection.put({
                                                        uid: collectedImage[0].uid,
                                                        prompt : prompt.prompt,
                                                        queue:  'RC' + (Math.random() + 1).toString(36).substring(2).toUpperCase(),// We don't have this value as it wasn't created in this playground - create a dummy value
                                                        timestamp: Date.now(),
                                                    });
                                                })
                                                .finally(() => {
                                                    console.log("Added image history to local db");
                                                })
    
                                            // Check if image already exists before inserting
                                            const existingImage = await db.images.where('hash').equals(collectedImage[0].hash).first();
                                            if (!existingImage) {
                                                await db.images.put({
                                                   image : collectedImage[0].image,
                                                   seed: collectedImage[0].seed,
                                                   uid: collectedImage[0].uid,
                                                   model: collectedImage[0].model,
                                                   inCollection: false,
                                                   hash: collectedImage[0].hash,
                                                   online: collectedImage[0].online,
                                                   tag: collectedImage[0].tag,
                                                   dataType: collectedImage[0].dataType || 'image'
                                               });
                                            } else {
                                                // Update existing image's inCollection status
                                                await db.images.where('hash').equals(collectedImage[0].hash).modify({inCollection: false});
                                            }
                                        }
                                    });
                                }
    
    
                                db.collectedImages.where('image').equals(props.image).delete();
                                console.log("Removing image from collection DB");
                                deleteCollectionImage(accountContext.accountDetails.accountNo, props.hash)
                                props.refreshImages()
                            }
                        } else {
                            // adding the image to the collection
                            let iCount
                            await db.collectedImages.count((collectedCount) => {
                                iCount = collectedCount + 1;
                            })
                            console.log("Adding image to collection DB: ", iCount);
                            console.log(props);
    
                            // Detect media type before saving
                            const mediaType = props.dataType || 'image'; // Use existing dataType or default to 'image'
                            // Check if image already exists in collection before inserting
                            const existingCollectedImage = await db.collectedImages.where('hash').equals(props.hash).first();
                            if (!existingCollectedImage) {
                                await db.collectedImages.put({uid: props.uid, imageID: iCount, image: props.image, seed: props.seed, model: props.model, hash: props.hash, online: props.online, tag: props.tag, prompt:promptInfo.prompt, public: false, dataType: mediaType});
                            } else {
                                console.log("Image already exists in collection with hash:", props.hash);
                            }

    
                            getSpecificImage(props.uid).then(async(image) => {
                                let fileExt = ''
                                let imageData = props.image;

                                // const mediaType = await fetchMediaType(props.image, {returnExtension: false});
                                // console.log("[MEDIA TYPE] Media Type: ", mediaType);
                                // if (!props.image.includes(':\\') && !props.image.includes('https')) {
                                //     fileExt = await getMediaType(props.image, true)
                                // }

                                let imageArr = [{
                                    uid: props.uid,
                                    image: imageData,
                                    seed: props.seed,
                                    model: props.model,
                                    hash: props.hash,
                                    online: props.online,
                                    tag: props.tag,
                                    prompt:promptInfo.prompt,
                                    dataType: "image",
                                }]
                                let colArr = null
                                if (image) {
                                    colArr = JSON.stringify([image])
                                }
                                // If in Electron and image is a file path, read the file and convert to base64
                                if (electronBridge.isElectron && props.image.includes(':\\')) {
                                    const tokens = getAuthorizationToken();
                                    const devAPI = await getUseDepApi();
                                    console.log("Going through the update PWA call: ", imageArr, " | ", colArr);
                                    
                                    electronBridge.ipcRenderer.invoke('collection_upload', JSON.stringify(imageArr), accountContext.accountDetails.accountNo, null, colArr, tokens, devAPI);
                                } else {
                                    console.log("Going through the update API call: ", imageArr, " | ", colArr);
                                    updateAccount(JSON.stringify(imageArr), accountContext.accountDetails.accountNo, null, colArr)
                                }
                            });
                        }
                    });
                    // props.refreshImages();
                }).then(async () => {
                    setLocalInCollection(!localInCollection);
                    if (soundSettingCheck?.value && inCollection) {
                        // const collectAudio = new Audio(CollectSound);
                        collectAudio.loop = false;
                        collectAudio.volume = 0.8;
                        try {
                            await collectAudio.play();
                        } catch (error) {
                            // Ignore interruption errors
                            if (error.name !== 'AbortError') {
                                console.error('Collection sound play error:', error);
                            }
                        }
                    }
                });
            // Add a delay to ensure API processing
            await new Promise(resolve => setTimeout(resolve, 2000));
        } else {
            db.collectedImages.where('image').equals(props.image).delete();
            console.log("Removing image from collection DB");
            deleteCollectionImage(accountContext.accountDetails.accountNo, props.hash)
            props.refreshImages()
        }

    } catch (error){
        console.error(`Error removing image from My Collection: ${error}`)
    } finally {
        // Release the toggle lock
        await db.settings.put({ key: 'toggleLock', value: false });
    }
}

    const deleteImage = async () => {
        console.log(props);
        
        let imageNotFound = false;
        if (props.isMyCollection) {
            db.collectedImages
                .where("image")
                .equals(props.image)
                .delete()
                .then(async () => {
                    console.log("check if image is in generated images and remove the flag");
                    // check if image is in generated images and remove the flag
                    await db.images.where('image').equals(props.image).toArray(async(images) => {
                        if (images.length > 0) {
                            // removing the image from the collection
                            db.images.update(images[0].id, {inCollection: false})
                            console.log("Removing image from collection");
                            Swal.fire({
                                color: "#190A4E",
                                title: "Confirm Delete",
                                text: `Are you sure you want to delete this image from your ${props.isMyCollection ? "Collection" : "Playground"}?`,
                                icon: "info",
                                confirmButtonText: 'Yes',
                                confirmButtonColor: "#FFB02E",
                                showDenyButton: true,
                                denyButtonText: "No",
                                denyButtonColor: "#190A4E",
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    deleteCollectionImage(accountContext.accountDetails.accountNo, images[0].hash)
                                    .then((data) => props.refreshImages())
                                }
                            })
                        } else {
                            imageNotFound = true;
                        }
                    });
                    if (imageNotFound) {
                        Swal.fire({
                            color: "#190A4E",
                            title: "Confirm Delete",
                            text: `Are you sure you want to delete this image from your ${props.isMyCollection ? "Collection" : "Playground"}?`,
                            icon: "info",
                            confirmButtonText: 'Yes',
                            confirmButtonColor: "#FFB02E",
                            showDenyButton: true,
                            denyButtonText: "No",
                            denyButtonColor: "#190A4E",
                        }).then((result) => {
                            if (result.isConfirmed) {
                                deleteCollectionImage(accountContext.accountDetails.accountNo, props.hash)
                                .then((data) => props.refreshImages())
                            }
                        })
                    }
                });
            return;
        }
        Swal.fire({
            color: "#190A4E",
            title: "Confirm Delete",
            text: `Are you sure you want to delete this image from your ${props.isMyCollection ? "Collection" : "Playground"}?`,
            icon: "info",
            confirmButtonText: 'Yes',
            confirmButtonColor: "#FFB02E",
            showDenyButton: true,
            denyButtonText: "No",
            denyButtonColor: "#190A4E",
        }).then((result) => {
            if (result.isConfirmed) {
                db.images
                .where("id")
                .equals(props.id)
                .delete()
                .then(props.refreshImages);
            }
        })

    }

    const getBlobFromSource = async (source, contentType) => {
        if (!source) {
          throw new Error("No source provided");
        }
      
        // 1) If it looks like a URL (http, https, /, blob:) or a local file path
        const looksLikeUrl =
          source.startsWith("http://") ||
          source.startsWith("https://") ||
          source.startsWith("/") ||
          source.startsWith("blob:") ||
          /^[a-zA-Z]:\\/.test(source);
      
        if (looksLikeUrl) {
          // Fetch the file from the URL
          const response = await fetch(source);
          if (!response.ok) {
            throw new Error("Failed to fetch file: " + response.status);
          }
          // Let the browser decide contentType from the response,
          // or override if you really want
          const blob = await response.blob();
          if (contentType) {
            return blob.slice(0, blob.size, contentType);
          }
          return blob;
        }
      
        // 2) Otherwise assume it's base64
      
        // If it's a data URL like "data:image/png;base64,AAAA..."
        const base64Part = source.includes(",") ? source.split(",")[1] : source;
      
        return base64toBlob(base64Part, contentType);
      };

    const base64toBlob = (b64Data, contentType='', sliceSize=512) => {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, {type: contentType});
        return blob;
    }

    const downloadImage = async (contentType, ext) => {
        const blobFile = await getBlobFromSource(props.image, contentType);

        if (window.showSaveFilePicker) {
            try {
                const handle = await window.showSaveFilePicker({
                    suggestedName: `${downloadName}.${ext}`,
                    types: [{ description: `${ext.toUpperCase()} Image`, accept: { [contentType]: [`.${ext}`] } }]
                });
                const writable = await handle.createWritable();
                await writable.write(blobFile);
                await writable.close();
                return;
            } catch (err) {
                if (err.name === 'AbortError') return;
                console.warn('showSaveFilePicker failed, falling back:', err);
            }
        }

        const blobUrl = URL.createObjectURL(blobFile);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = `${downloadName}.${ext}`;
        document.body.appendChild(link);
        link.dispatchEvent(new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
        }));
        document.body.removeChild(link);
    };

    const downloadUrlImage = async (ext = 'png') => {
        try {
            // Show loading indicator
            Swal.fire({
                title: 'Downloading Image...',
                text: 'Please wait while we fetch the image',
                allowOutsideClick: false,
                showConfirmButton: false,
                willOpen: () => {
                    Swal.showLoading();
                }
            });

            // Check if it's a URL
            if (props.image && props.image.includes('http')) {
                if (electronBridge.isElectron) {
                    // In Electron, we can bypass CORS by using IPC to download in main process
                    try {
                        const result = await electronBridge.ipcRenderer.invoke('download-url-image', {
                            url: props.image,
                            filename: `${downloadName}.${ext}`
                        });
                        
                        if (result.success) {
                            Swal.close();
                            Swal.fire({
                                title: 'Success!',
                                text: `Image saved to: ${result.path}`,
                                icon: 'success',
                                timer: 3000,
                                showConfirmButton: false
                            });
                        } else {
                            throw new Error(result.error || 'Download failed');
                        }
                    } catch (ipcError) {
                        console.warn('IPC download failed, trying direct fetch:', ipcError);
                        // Fall back to fetch method
                        await directDownload();
                    }
                } else {
                    // Web version - use direct download or open in new tab
                    await directDownload();
                }
                
                async function directDownload() {
                    try {
                        const response = await fetch(props.image);

                        if (!response.ok) {
                            throw new Error(`Failed to fetch image: ${response.statusText}`);
                        }

                        const blob = await response.blob();
                        const contentType = blob.type || 'image/png';

                        Swal.close();

                        if (window.showSaveFilePicker) {
                            try {
                                const handle = await window.showSaveFilePicker({
                                    suggestedName: `${downloadName}.${ext}`,
                                    types: [{ description: `${ext.toUpperCase()} Image`, accept: { [contentType]: [`.${ext}`] } }]
                                });
                                const writable = await handle.createWritable();
                                await writable.write(blob);
                                await writable.close();

                                Swal.fire({
                                    title: 'Success!',
                                    text: 'Image saved successfully',
                                    icon: 'success',
                                    timer: 2000,
                                    showConfirmButton: false
                                });
                                return;
                            } catch (err) {
                                if (err.name === 'AbortError') return;
                                console.warn('showSaveFilePicker failed, falling back:', err);
                            }
                        }

                        const blobUrl = URL.createObjectURL(blob);
                        const link = document.createElement("a");
                        link.href = blobUrl;
                        link.download = `${downloadName}.${ext}`;
                        document.body.appendChild(link);
                        link.dispatchEvent(new MouseEvent('click', {
                            bubbles: true,
                            cancelable: true,
                            view: window
                        }));
                        document.body.removeChild(link);

                        URL.revokeObjectURL(blobUrl);

                        Swal.fire({
                            title: 'Success!',
                            text: 'Image downloaded successfully',
                            icon: 'success',
                            timer: 2000,
                            showConfirmButton: false
                        });
                    } catch (fetchError) {
                        // If fetch fails due to CORS, just open the image in a new tab
                        console.warn('Direct fetch failed, opening in new tab:', fetchError);
                        Swal.close();

                        // Open in new tab as fallback
                        window.open(props.image, '_blank');

                        Swal.fire({
                            title: 'Opening in New Tab',
                            text: 'Image opened in a new tab. You can right-click to save it.',
                            icon: 'info',
                            confirmButtonText: 'Ok',
                            confirmButtonColor: '#FFB02E',
                        });
                    }
                }
            }
        } catch (error) {
            console.error('Error downloading URL image:', error);
            Swal.fire({
                title: 'Download Failed',
                text: error.message || 'Unable to download image from URL',
                icon: 'error',
                confirmButtonText: 'Ok',
                confirmButtonColor: '#FFB02E',
            });
        }
    };

    const downloadPrompt = async () => {
        console.log("DOWNLOADING PROMPT")
        const item = await db.collection.where('uid').equals(props.uid).first();

        if (item) {
            console.log('[PROMPT_DOWNLOAD] Prompt file downloaded (existing):', item);
            downloadString(JSON.stringify(item), 'application/json', `${downloadName}.prompt`);
        } else {
            // THIS SHOULD BE IN THE SAME FORMAT AS getImageMetadata
            await getPromptFileData(accountContext.accountDetails.accountNo, props.uid).then((prompt) => {
                console.log('[PROMPT_DOWNLOAD] Prompt file downloaded (API):', prompt);
                db.collection.put({
                    uid: prompt.uid,
                    prompt : prompt,
                    queue:  'RC' + (Math.random() + 1).toString(36).substring(2).toUpperCase(),// We don't have this value as it wasn't created in this playground - create a dummy value
                    timestamp: Date.now(),
                });
                downloadString(JSON.stringify(prompt), 'application/json', `${downloadName}.prompt`);
            });
        }

    }

    const copyImageToClipboard = async () => {
        try {
            const isUrl = props.image && (props.image.startsWith('http://') || props.image.startsWith('https://'));
            const isLocalPath = props.image && (props.image.includes(':\\') || props.image.startsWith('/'));

            if (isUrl) {
                const response = await fetch(props.image);
                const originalBlob = await response.blob();
                const pngBlob = new Blob([originalBlob], { type: 'image/png' });

                if (navigator.clipboard && navigator.clipboard.write) {
                    await navigator.clipboard.write([
                        new ClipboardItem({ 'image/png': pngBlob })
                    ]);
                    console.log('Image copied to clipboard (URL)');

                    Swal.fire({
                        icon: 'success',
                        title: 'Copied!',
                        text: 'Image copied to clipboard',
                        timer: 1500,
                        showConfirmButton: false,
                        position: 'top-end',
                        toast: true
                    });
                } else {
                    Swal.fire({
                        icon: 'warning',
                        title: 'Not supported',
                        text: 'Clipboard operations are not available in this browser',
                        timer: 2000,
                        showConfirmButton: false,
                        position: 'top-end',
                        toast: true
                    });
                }
            } else if (isLocalPath && electronBridge.isElectron) {
                const { clipboard, nativeImage } = window.require('electron');
                const fs = window.require('fs');

                const buffer = fs.readFileSync(props.image);
                const image = nativeImage.createFromBuffer(buffer);
                clipboard.writeImage(image);

                Swal.fire({
                    icon: 'success',
                    title: 'Copied!',
                    text: 'Image copied to clipboard',
                    timer: 1500,
                    showConfirmButton: false,
                    position: 'top-end',
                    toast: true
                });
            } else {
                const blob = base64toBlob(props.image, 'image/png');

                if (navigator.clipboard && navigator.clipboard.write) {
                    await navigator.clipboard.write([
                        new ClipboardItem({
                            [blob.type]: blob
                        })
                    ]);
                    console.log('Image copied to clipboard');

                    Swal.fire({
                        icon: 'success',
                        title: 'Copied!',
                        text: 'Image copied to clipboard',
                        timer: 1500,
                        showConfirmButton: false,
                        position: 'top-end',
                        toast: true
                    });
                } else if (electronBridge.isElectron) {
                    const { clipboard, nativeImage } = window.require('electron');

                    const buffer = Buffer.from(props.image, 'base64');
                    const image = nativeImage.createFromBuffer(buffer);

                    clipboard.writeImage(image);
                    console.log('Image copied to clipboard (Electron)');

                    Swal.fire({
                        icon: 'success',
                        title: 'Copied!',
                        text: 'Image copied to clipboard',
                        timer: 1500,
                        showConfirmButton: false,
                        position: 'top-end',
                        toast: true
                    });
                } else {
                    console.warn('Clipboard operations not supported in this environment');
                    Swal.fire({
                        icon: 'warning',
                        title: 'Not supported',
                        text: 'Clipboard operations are not available in this browser',
                        timer: 2000,
                        showConfirmButton: false,
                        position: 'top-end',
                        toast: true
                    });
                }
            }
        } catch (error) {
            console.error('Failed to copy image to clipboard:', error);

            Swal.fire({
                icon: 'error',
                title: 'Copy Failed',
                text: 'Failed to copy image to clipboard. Please try again.',
                confirmButtonColor: '#190A4E'
            });
        }
    }

    const handleTagging = () => {
        setOptions([]);

        const combinedTags = [...collectionContext.tags, ...collectionContext.collectionTags];
        const uniqueTags = [...new Set(combinedTags)];

        const sortedTags = uniqueTags.sort((a, b) => a.localeCompare(b));
        setOptions(sortedTags.map(tag => ({ value: tag, label: tag })));
        setOpen(true)
    }

    useEffect(() => {}, [tag])

    // Handle click outside for mobile toolbar
    useEffect(() => {
        if (!isMobile) return;

        const handleClickOutside = (event) => {
            if (
                toolbarRef.current && 
                !toolbarRef.current.contains(event.target) &&
                menuButtonRef.current &&
                !menuButtonRef.current.contains(event.target)
            ) {
                setShowMobileToolbar(false);
            }
        };

        if (showMobileToolbar) {
            document.addEventListener('mousedown', handleClickOutside);
            document.addEventListener('touchstart', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('touchstart', handleClickOutside);
        };
    }, [showMobileToolbar, isMobile]);

    const editTagOnImage = () => {
        setTagLoading(true);
        let multiOptions = "";
        let initTag
        let concate

        setTimeout(() => {
            if (isUndefined(props.tag) == false) {
                if (clearTags == false) {
                    initTag = props.tag + ","
                } else {
                    initTag = "";
                }
            } else {
                initTag = "";
            }
            if (selectedOptions !== "" && !selectedOptions.includes("undefined")) {
                selectedOptions.map((arrValue) => {
                    if (!initTag.includes(arrValue.value) || clearTags == true){
                        multiOptions += arrValue.value + ",";
                    }
                })
                initTag += multiOptions;
            }


        }, 1000)

        setTimeout(() => {
            if (inputTag !== "") {
                if (!initTag.includes(inputTag)){
                    concate = initTag + inputTag
                } else {
                    concate = initTag
                }
            } else {
                concate = initTag;
            }   
            if (concate.endsWith(',')) {
                concate = concate.slice(0, -1);
            }
            if (concate.startsWith(',')) {
                concate = concate.substring(1);
            }
            if (concate == '') {
                Swal.fire({
                    color: "#190A4E",
                    title: "Tag Empty",
                    text: "You cannot tag an image with an empty tag. Please add a tag to the image before proceeding.",
                    icon: "info",
                    timer: 2000,
                    timerProgressBar: true,
                    showConfirmButton: false
                })
                setTagLoading(false);
                return;
            }  
            setTag(concate)
            console.log("Tagging Image: ", props.dbTable.core.name);
            
            if (props.dbTable.core.name == "images") {
                props.dbTable.update(props.id, {tag: concate}).then(async(updated) => {
                    if (updated) {
                        if (props.isMyCollection) {
                            // Update the tag in the images table if it exists
                            let generatedImages = [];
                            await db.images.reverse().toArray((images) => {
                                generatedImages = images;
                            });
                            let imageInImagesTable;
                            generatedImages.forEach((image) => {
                                if (image.hash === props.hash) {
                                    imageInImagesTable = image;
                                }
                            })
                            if (imageInImagesTable) {
                                db.images.update(imageInImagesTable.id, { tag: concate });
                            } else {
                                console.log("Image not found in the images table");
                            }
                            console.log("Update Image Tags Route: ", props.hash);
                            updateImageTags(accountContext.accountDetails.accountNo, props.hash, concate)
    
                        } else {
                            let collectionImages = [];
                            await db.collectedImages.reverse().toArray((images) => {
                                collectionImages = images;
                            });
                            let imageInCollectionTable;
                            collectionImages.forEach((image) => {
                                if (image.hash === props.hash) {
                                    imageInCollectionTable = image;
                                }
                            })
                            if (imageInCollectionTable) {
                                db.collectedImages.update(imageInCollectionTable.id, { tag: concate });
                            } else {
                                console.log("Image not found in the collection table");
                            }
                        }
                        Swal.fire({
                            title:"Success",
                            text:"Your image was successfully tagged",
                            icon:"success",
                            timer: 1000,
                            showConfirmButton: false
                        }).then(() => {
                            setTagLoading(false);
                            setInputTag("");
                            setClearTags(false);
                            setSelectedOptions([]);
                            props.refreshTags();
                            if (!props.isMyCollection) {
                                props.refreshImages();
                            }
                            // props.refreshImages();
                        })
                        setOpen(false)
                    }
                })
            } else {
                // Update the tag in the images table if it exists
                (async () => {
                let generatedImages = [];
                await db.images.reverse().toArray((images) => {
                    generatedImages = images;
                });
                let imageInImagesTable;
                generatedImages.forEach((image) => {
                    if (image.hash === props.hash) {
                        imageInImagesTable = image;
                    }
                })
                if (imageInImagesTable) {
                    db.images.update(imageInImagesTable.id, { tag: concate });
                } else {
                    console.log("Image not found in the images table");
                }
                    console.log("Update Image Tags Route: ", props.hash);
                    updateImageTags(accountContext.accountDetails.accountNo, props.hash, concate)
                })()

                Swal.fire({
                    title:"Success",
                    text:"Your image was successfully tagged",
                    icon:"success",
                    timer: 1000,
                    showConfirmButton: false
                }).then(() => {
                    setTagLoading(false);
                    setInputTag("");
                    setClearTags(false);
                    setSelectedOptions([]);
                    props.refreshTags();
                    if (!props.isMyCollection) {
                        props.refreshImages();
                    }
                    // props.refreshImages();
                })
                setOpen(false)
            }

        }, 2500)

    }

    const handleClearTag = () => {
        setClearTags(!clearTags);
    }

    const handlePrivatePublic = async() => {
        if (accountContext.accountDetails.alias !== "") {
            setPrivateImage(!privateImage);
            if (!privateImage) {
                setVisibility("Private")
                console.log('Entire props during handle private public: ', props)
                console.log("Changing Image Visibility Route: ", props.hash);
                await changeImageVisibility(accountContext.accountDetails.accountNo, props.hash, 0)
                .then(() => {
                    console.log("Image Visibility Changed Successfully");
                })
                .catch((e) => {
                    console.log("Image Visibility did not change");
                    setVisibility("Public")
                    setPrivateImage(!privateImage);
                })
                // await props.dbTable.update(props.id, {uid: props.uid, image: props.image, seed: props.seed, model: props.model, hash: props.hash, online: props.online, tag: props.tag, prompt:promptInfo.prompt, public: false}).then(async(updated) => {
                //     if (updated) {
                //         setVisibility("Private")
                //         console.log("Changing Image Visibility Route: ", props.hash);
                //         await changeImageVisibility(accountContext.accountDetails.accountNo, props.hash, 0)
                //         .then(() => {
                //             console.log("Image Visibility Changed Successfully");
                //         })
                //         .catch((e) => {
                //             console.log("Image Visibility did not change");
                //             setVisibility("Public")
                //             setPrivateImage(!privateImage);
                //         })
                //         // props.refreshImages();
                //     }
                // })
            } else {
                setVisibility("Public")
                console.log("Changing Image Visibility Route: ", props.hash);
                await changeImageVisibility(accountContext.accountDetails.accountNo, props.hash, 1)
                .then(() => {
                    console.log("Image Visibility Changed Successfully");
                })
                .catch((e) => {
                    console.log("Image Visibility did not change");
                    setVisibility("Private")
                    setPrivateImage(!privateImage);
                })
                // await props.dbTable.update(props.id, {uid: props.uid, image: props.image, seed: props.seed, model: props.model, hash: props.hash, online: props.online, tag: props.tag, prompt:promptInfo.prompt, public: true}).then(async(updated) => {
                //     if (updated) {
                //         setVisibility("Public")
                //         console.log("Changing Image Visibility Route: ", props.hash);
                //         await changeImageVisibility(accountContext.accountDetails.accountNo, props.hash, 1)
                //         .then(() => {
                //             console.log("Image Visibility Changed Successfully");
                //         })
                //         .catch((e) => {
                //             console.log("Image Visibility did not change");
                //             setVisibility("Private")
                //             setPrivateImage(!privateImage);
                //         })
                //         // props.refreshImages();
                //     }
                // })
            }
        } else {
            Swal.fire({
                title: "No Username",
                text: "You need to have an username in order to make your images available to the public. Please login in to the website and set yourself a username before proceeding.",
                icon: "error",
                confirmButtonText: "Ok",
                confirmButtonColor: "#FFB02E",
            }).then((result) => {
                if (result.isConfirmed) {
                    window.open("https://login.promptus.ai/account", "_blank")
                }
            })
        }
    }

    const handleDblClick = (e) => {
        if (e.detail === 2) {
            console.log("Double Click");
            props.setZoomedImage({image: props.image, seed: props.seed})
        } else if (e.detail === 1) {
            console.log("Single Click - Populating prompt field");
        }
    }

    // Function to forcefully update the prompt input field
    const forceUpdatePromptField = (promptText, maxRetries = 5, delay = 200, currentRetry = 0) => {
        // Find the prompt input field 
        const promptField = document.querySelector('input[name="prompt"]');
        
        if (promptField) {
            console.log("Directly updating prompt field with text:", promptText);
            
            // Set value directly
            promptField.value = promptText;
            
            // Create and dispatch input event
            try {
                const inputEvent = new Event('input', { bubbles: true });
                promptField.dispatchEvent(inputEvent);
                
                // Also create and dispatch change event 
                const changeEvent = new Event('change', { bubbles: true });
                promptField.dispatchEvent(changeEvent);
                
                // Focus on the field
                promptField.focus();
                
                // Create React synthetic events (this is a bit of a hack)
                const nativeInputEvent = new Event('input', { bubbles: true, cancelable: true });
                const reactInputEvent = Object.create(nativeInputEvent);
                reactInputEvent.target = promptField;
                reactInputEvent.currentTarget = promptField;
                reactInputEvent.target.value = promptText;
                promptField.dispatchEvent(reactInputEvent);
                
                console.log("Successfully updated prompt field");
            } catch (err) {
                console.error("Error dispatching events to prompt field:", err);
            }
        } else if (currentRetry < maxRetries) {
            // Retry with exponential backoff
            console.log(`Prompt field not found, retrying in ${delay}ms (${currentRetry + 1}/${maxRetries})`);
            setTimeout(() => {
                forceUpdatePromptField(promptText, maxRetries, delay * 1.5, currentRetry + 1);
            }, delay);
        } else {
            console.error("Failed to find prompt field after maximum retries");
        }
    };
    
    // Get the prompt for the image and populate the prompt field
    const getPromptForImage = async () => {
        // Show immediate visual feedback
        setImageClicked(true);
        
        // Reset the visual feedback after 500ms
        setTimeout(() => {
            setImageClicked(false);
        }, 500);
        
        try {
            // Try to set the model if it's available
            if (props.model) {
                console.log("Setting model to:", props.model);
                try {
                    // Force advanced settings to show
                    driverContextDispatch({type: 'advanced'});
                    
                    // Ensure we have a clean string
                    const modelString = typeof props.model === 'string' ? props.model : 
                        (props.model ? String(props.model).trim() : '');
                    
                    // Use a more specific key that's less likely to conflict
                    const selectedModelKey = `selected_model_${Date.now()}`;
                    
                    // Store model information with a timestamp to ensure it's fresh
                    localStorage.setItem(selectedModelKey, modelString);
                    
                    // Also store it in the standard location for backward compatibility
                    localStorage.setItem('selected_model', modelString);
                    
                    // Set a trigger in localStorage that PromptHeader checks for
                    localStorage.setItem('model_selection_pending', 'true');
                    
                    // Update directly if possible via window events
                    try {
                        const event = new CustomEvent('modelSelected', { 
                            detail: { model: modelString }
                        });
                        window.dispatchEvent(event);
                    } catch (e) {
                        console.error("Error dispatching model selection event:", e);
                    }
                    
                    // Show feedback about model selection
                    Swal.fire({
                        title: "Model Selected",
                        text: `Model set to ${props.model}`,
                        icon: "success",
                        toast: true,
                        position: "top-end",
                        showConfirmButton: false,
                        timer: 2000,
                        timerProgressBar: true
                    });
                } catch (error) {
                    console.error("Error setting model:", error);
                }
            }
            
            // Create a function to update the prompt properly
            const updatePromptFields = (promptText) => {
                // // Update the prompt context - Removed as PromptHeader now uses event listener
                // updatePrompt(promptText);
                
                // Dispatch custom event
                try {
                    console.log("Dispatching promptUpdated event with prompt:", promptText);
                    const event = new CustomEvent('promptUpdated', { 
                        detail: { prompt: promptText }
                    });
                    window.dispatchEvent(event);
                } catch (e) {
                    console.error("Error dispatching prompt update event:", e);
                }
            };
            
            const imageDetails = await db.collection.where('uid').equals(props.uid).toArray();
            if (imageDetails.length > 0 && imageDetails[0].prompt) {
                let prompt = imageDetails[0].prompt;
                console.log("Found prompt for image:", prompt);
                
                // Extract the actual prompt text - need to handle various structures
                let promptText = "";
                if (typeof prompt === 'string') {
                    promptText = prompt;
                } else if (prompt.prompt) {
                    if (typeof prompt.prompt === 'string') {
                        promptText = prompt.prompt;
                    } else if (prompt.prompt.prompt) {
                        promptText = prompt.prompt.prompt;
                    }
                }
                
                console.log("Extracted prompt text:", promptText);
                
                if (promptText && promptText.trim() !== "") {
                    updatePromptFields(promptText);
                    
                    // Show feedback to the user that the prompt was populated
                    Swal.fire({
                        title: "Prompt Populated",
                        text: "The prompt for this image has been added to the prompt field",
                        icon: "success",
                        toast: true,
                        position: "top-end",
                        showConfirmButton: false,
                        timer: 2000,
                        timerProgressBar: true
                    });
                    return;
                }
            }
            
            // Try to get the prompt from props.prompt
            if (props.prompt) {
                console.log("Using props.prompt:", props.prompt);
                
                let promptText = "";
                if (typeof props.prompt === 'string') {
                    promptText = props.prompt;
                } else if (props.prompt.prompt) {
                    if (typeof props.prompt.prompt === 'string') {
                        promptText = props.prompt.prompt;
                    } else if (props.prompt.prompt.prompt) {
                        promptText = props.prompt.prompt.prompt;
                    }
                }
                
                console.log("Extracted prompt text from props.prompt:", promptText);
                
                if (promptText && promptText.trim() !== "") {
                    updatePromptFields(promptText);
                    
                    Swal.fire({
                        title: "Prompt Populated",
                        text: "Prompt information has been added to the field",
                        icon: "success",
                        toast: true,
                        position: "top-end",
                        showConfirmButton: false,
                        timer: 2000,
                        timerProgressBar: true
                    });
                    return;
                }
            }
            
            // Try promptInfo as fallback
            if (promptInfo && promptInfo.prompt) {
                console.log("Using promptInfo:", promptInfo);
                
                let promptText = "";
                if (typeof promptInfo.prompt === 'string') {
                    promptText = promptInfo.prompt;
                } else if (promptInfo.prompt.prompt) {
                    promptText = promptInfo.prompt.prompt;
                }
                
                console.log("Extracted prompt text from promptInfo:", promptText);
                
                if (promptText && promptText.trim() !== "") {
                    updatePromptFields(promptText);
                    
                    Swal.fire({
                        title: "Prompt Populated",
                        text: "Prompt information has been added to the field",
                        icon: "success",
                        toast: true,
                        position: "top-end",
                        showConfirmButton: false,
                        timer: 2000,
                        timerProgressBar: true
                    });
                    return;
                }
            }
            
            // If all else fails, try to retrieve the prompt from the API using hash
            if (props.hash) {
                console.log("Attempting to get prompt from API using hash:", props.hash);
                
                Swal.fire({
                    title: "Retrieving Prompt",
                    text: "Fetching prompt information...",
                    icon: "info",
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 1500
                });
                
                try {
                    // First check if we can get it from getPromptFileData
                    const prompt = await getPromptFileData(accountContext.accountDetails.accountNo, props.uid);
                    console.log("Got prompt from API:", prompt);
                    
                    if (prompt && (prompt.prompt || typeof prompt === 'string')) {
                        let promptText = typeof prompt === 'string' 
                            ? prompt 
                            : (prompt.prompt ? prompt.prompt : "");
                        
                        if (promptText && promptText.trim() !== "") {
                            updatePromptFields(promptText);
                            
                            Swal.fire({
                                title: "Prompt Populated",
                                text: "Successfully retrieved prompt information",
                                icon: "success",
                                toast: true,
                                position: "top-end",
                                showConfirmButton: false,
                                timer: 2000,
                                timerProgressBar: true
                            });
                            return;
                        }
                    }
                } catch (error) {
                    console.warn("Error getting prompt from API:", error);
                }
            }
            
            // If we reach here, we couldn't find a valid prompt
            Swal.fire({
                title: "Prompt Not Found",
                text: "Could not find the prompt for this image",
                icon: "warning",
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 2000
            });
            
        } catch (error) {
            console.error("Error retrieving prompt for image:", error);
            Swal.fire({
                title: "Error",
                text: "Could not retrieve the prompt for this image",
                icon: "error",
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 2000
            });
        }
    }

    const handleEnter = (e) => {
        if (e.key === "Enter") {
            editTagOnImage();
        }
    }

    const handleDragStart = (e) => {
        if (props.image) {
            let imageToDrag = props.image && props.image.includes(":\\") ? toFileUrl(props.image) : `data:image/png;base64,${props.image}`;
            e.dataTransfer.setData('text/plain', window.location.href);
            e.dataTransfer.setData('text/uri-list', imageToDrag);
        }
    }

    const toFileUrl = (filePath) => {
        return filePath;
      }

    useEffect(() => {
        if (props.image && props.image !== '') {
            (async () => {
                await db.settings.toArray((settings) => {
                    settings.forEach(setting => {
                        if (setting.key === "local_directory") {
                            setLocalDirectory(setting.value);
                        }
                    })
                })
                try {
                    const imageDimensions = await getImageDimensions(props.image)
                    // if (electronBridge.isElectron) {
                    //     const image = await Image.load(props.image && props.image.includes(":\\") ? toFileUrl(props.image) : `data:image/png;base64,${props.image}`);
                    //     setDimensions(`${image.width} x ${image.height}`); 
                    // } else {
                    //     const image = await Image.load(`data:image/*;base64,${props.image}`);
                    //     setDimensions(`${image.width} x ${image.height}`);
                    // } 
                    setDimensions(`${imageDimensions.width} x ${imageDimensions.height}`);
                } catch (err) {
                    console.error("Error loading image:", err);
                }
            })();
        }
    }, []);

    useEffect(() => {
        if (!props.image || props.image === '' || !props.id) return;
        if (props.image.includes(':\\') || props.image.includes(':/') || props.image.startsWith('/')) return;

        (async () => {
            try {
                const detectedType = await fetchMediaType(props.image);
                const normalizedType = detectedType?.toLowerCase() || 'image';
                const currentDataType = props.dataType?.toLowerCase() || 'image';
                if (normalizedType !== currentDataType && ['image', 'video', 'audio'].includes(normalizedType)) {
                    console.log(`[MEDIA_MATCH_CHECK] DataType mismatch detected for id ${props.id}: stored="${currentDataType}", actual="${normalizedType}". Updating...`);
                    await db.images.update(props.id, { dataType: normalizedType });
                    props.refreshImages?.();
                }
            } catch (err) {
                console.error("[MEDIA_MATCH_CHECK] Error detecting media type:", err);
            }
        })();
    }, [props.image, props.id, props.dataType]);

    const getBorderColor = () => {
        if (props.uid?.toLowerCase().includes("momm")) {
            return 'border-green-500';
        }

        switch (props.serverType) {
            case 'gpu':
            case 'cpu':
                return 'border-white';
            case 'cosy':
                return 'border-cyan';
            case 'online':
            default:
                return props.online === false ? 'border-white' : 'border-amber-500';
        }
    };

    const borderColor = getBorderColor();

    let regenerating = false;
    const regenerateImage = async(workload) => {
        if (regenerating) {
            console.log("The image regeneration process is already happening");
            return
        };

        regenerating = true;
        console.log("Regenerating Image");
        console.log("UID: ", props);
        let noImages = false;
        if (apiState.online == true) {
            await getProgress(props.uid, false, apiState, generateStatusDispatch).then(async(data) => {
                if (data && data.output && Array.isArray(data.output) && data.output.length > 0) {
                    const results = await db.images.where('uid').equals(props.uid).and(item => item.image === '').toArray();
                    const deliveredImages = await db.images.where('uid').equals(props.uid).and(item => item.image !== '').toArray();
                    console.log("Results: ", results);                    

                    const filteredData = data.output.filter(item1 =>
                        deliveredImages.every(item2 => item2.hash !== item1.uid)
                      );

                    console.log("Filtered Data: ", filteredData);
                    
                    
                    const missingImagesCount = results.length;
                    const returnedImagesCount = filteredData.length;
                    let index = 0;
                    
                    if (!workload) {
                        if (missingImagesCount > 1 && returnedImagesCount !== 0) {
                            Swal.fire({
                                title: "Image found in server",
                                text: "Image found in the server that could not make it to you are being retrieved. Please wait ...",
                                icon: "info",
                                timer: 2500,
                                timerProgressBar: true,
                                showConfirmButton: false
                            })
                            const outputUid = filteredData[0].uid;
                            console.log("Output UID from single image: ", outputUid);
                            const hashcheck = await db.images.where('hash').equals(outputUid).first();
                            const image = await getGenerateOutput(props.uid, outputUid);
                            const imageCheck = await db.images.where('image').equals(image.image).first(); 
                            const dataType = await getMediaType(image.image)
                            let savedFilePath = null;
                            if (electronBridge.isElectron) {
                                if (typeof image.image == 'string') {
                                    savedFilePath = await electronBridge.ipcRenderer.invoke("test_upload", image.image, localDirectory, null, dataType)
                                }
                            } 
                            if (!hashcheck && !imageCheck) {
                                const safeUrl = (image.url && typeof image.url === 'string' && image.url.startsWith('https://') && !image.url.startsWith('data:')) ? image.url : null;
                                await db.images.update(results[0].id, {
                                    image: electronBridge.isElectron ? savedFilePath : image.image,
                                    seed: image.seed,
                                    model: image.model ?? '',
                                    hash: outputUid,
                                    prompt: image.prompt,
                                    receivedtimestamp: Date.now(),
                                    url: safeUrl
                                })
                                setReceived(props.uid, outputUid);
                                props.refreshImages();
                            } else {
                                console.log("Image already exists in the local DB, skipping ...");
                            }
                        } else {
                            noImages = true;
                        }

                    } else {
                        if (missingImagesCount > 1 && returnedImagesCount !== 0) {
                            Swal.fire({
                                title: "Image(s) found in server",
                                text: "Image(s) found in the server that could not make it to you are being retrieved. Please wait ...",
                                icon: "info",
                                timer: 2500,
                                timerProgressBar: true,
                                showConfirmButton: false
                            })
                        }
                        await Promise.all(
                            filteredData.map(async(item) => {
                                if (index > missingImagesCount) {
                                    console.log("More images returned than missing, stopping the loop.");
                                    if (props.image === '') {
                                        noImages = true;
                                    }
                                } else {
                                    const outputUid = item.uid;
                                    console.log("Output UID from workload: ", outputUid);
                                    const hashcheck = await db.images.where('hash').equals(outputUid).first();
                                    const image = await getGenerateOutput(props.uid, outputUid);
                                    const imageCheck = await db.images.where('image').equals(image.image).first();
                                    const dataType = await getMediaType(image.image)
                                    let savedFilePath = null;
                                    if (electronBridge.isElectron) {
                                        if (typeof image.image == 'string') {
                                            savedFilePath = await electronBridge.ipcRenderer.invoke("test_upload", image.image, localDirectory, null, dataType)
                                        }
                                    } 
                                    
                                    if (!hashcheck && !imageCheck) {
                                        const safeUrl = (image.url && typeof image.url === 'string' && image.url.startsWith('https://') && !image.url.startsWith('data:')) ? image.url : null;
                                        await db.images.update(results[index].id, {
                                            image: electronBridge.isElectron ? savedFilePath : image.image,
                                            seed: image.seed,
                                            model: image.model ?? '',
                                            hash: outputUid,
                                            prompt: image.prompt,
                                            receivedtimestamp: Date.now(),
                                            url: safeUrl
                                        })
                                        setReceived(props.uid, outputUid);
                                        props.refreshImages();
                                    } else {
                                        console.log("Image already exists in the local DB, skipping ...");
                                    }
                                }
                                index++;
                            })
                        )
                        // for (const item of filteredData) {
                        // }
                        if (missingImagesCount > returnedImagesCount) {
                            console.log("More missing images than returned images, some images are still missing.");
                            if (props.image === '') {
                                noImages = true;                    
                            }
                        }
                    }
                } else {
                    noImages = true;
                }
            });
        }
        
        if (apiState.online == false || noImages && props.image === '') {            
            console.log("Regenerating image due to no images in server present or offline mode");
            setImageIDRegenerating(props.id);
            const imageDetails = await db.collection.where('uid').equals(props.uid).toArray();
            let prompt = imageDetails[0].prompt;
            if (!workload) {
                console.log("Image Regeneration");
                prompt.prompt.count = 1;
                if (prompt?.prompt?.params) {
                  prompt.prompt.params.count = 1;
                }
                setWorkloadRegenerating(false);
                setWorkloadUidRegenerating("");
                generateStatusDispatch({type: 'failedImageID', failedImageID: props.id});
                generateStatusDispatch({type: 'failedWorkloadUID', failedWorkloadUID: null});
            } else {
                console.log("Workload Regeneration");
                const results = await db.images.where('uid').equals(props.uid).and(item => item.image === '').toArray();
                console.log('[REGEN IMAGE] Results: ', results);
                
                prompt.prompt.count = results.length;
                if (prompt?.prompt?.params) {
                  prompt.prompt.params.count = results.length;
                }
                setWorkloadRegenerating(true);
                setWorkloadUidRegenerating(props.uid);
                generateStatusDispatch({type: 'failedWorkloadUID', failedWorkloadUID: props.uid});
                generateStatusDispatch({type: 'failedImageID', failedImageID: null});
            }
            // prompt.prompt.params.image_batch_size = 1;
            console.log("[REGEN IMAGE] Prompt: ", prompt);
            props.regenerateImage(prompt, true, props.id);
        }
        regenerating = false;
    }

    const viewDetails = async(e) => {
        if (e) {
            e.stopPropagation(); // Stop event propagation to prevent image click handler from firing
        }
        
        // Close any existing zoom modals before opening details
        if (zoomedImage) {
            setZoomedImage(null); // Close local zoom modal
        }
        if (props.setZoomedImage) {
            props.setZoomedImage(null); // Close parent zoom modal if function is provided
        }
        
        // Check if viewFailedImage prop exists
        if (!props.viewFailedImage) {
            console.error("viewFailedImage prop is not provided");
            return;
        }
        
        const imageDetails = await db.collection.where('uid').equals(props.uid).toArray();
        if (imageDetails.length > 0) {
            let prompt = imageDetails[0].prompt;
            const details = prompt.prompt || prompt;
            props.viewFailedImage({
                ...details,
                id: props.id,
                uid: props.uid,
                hash: props.hash,
                jobUid: imageDetails[0].uid
            });
        } else {
            // For images not in collection, pass full props
            props.viewFailedImage({
                id: props.id,
                uid: props.uid,
                hash: props.hash,
                prompt: props.prompt,
                negative_prompt: props.negative_prompt,
                seed: props.seed,
                model: props.model,
                params: props.params
            })
        }
    }

    useEffect(() => {
        if (props.image !== '') {
            setFailedImage(false);
        }
    }, [props.image])

    useEffect(() => {
        if (generateStatus.status === 'loading' && props.id === generateStatus.failedImageID && generateStatus.failedImage) {
            console.log("This image failed to generate and is now regenerating: ", props.id, imageIDRegenerating);
            setImageRegenerating(true);
        } else if (generateStatus.status === 'loading' && props.uid === generateStatus.failedWorkloadUID && generateStatus.failedImage) {
            console.log("This image failed to generate and is now regenerating: ", props.uid, workloadUidRegenerating);
            setImageRegenerating(true);
        }
        if (generateStatus.status === 'loading') {
            setRegenLogic(true);
        }
        if (generateStatus.status === 'ready' || generateStatus.status === 'done' || generateStatus.status === 'error' || generateStatus.status === 'canceling') {
            setImageRegenerating(false);
            setRegenLogic(false);
        }
    }, [generateStatus.status])

    // useEffect(() => {
    //     if (workloadRegenerating && workloadUidRegenerating === props.uid) {
    //         setImageRegenerating(true);
    //     } else {
    //         setImageRegenerating(false);
    //     }
    // }, [workloadRegenerating])

    const handleDescribeImage = async() => {
        console.log("Describe the image")

        setOpenDescribeImage(true)
        setImageDescription("Generating ...");
        setImageDescriptionLoading(true);

        let imageDescription = "";
        const item = await db.imageDescriptions.where('hash').equals(props.hash).first();

        if (item) {
            console.log("Pulling description from local db")
            imageDescription = item.description
            setImageDescription(imageDescription);
            setImageDescriptionLoading(false);
        } else {
            console.log("Pulling description from api")

            let imageDescription ;
            
            if (props.inCollection) {
                imageDescription = getImageDescription(accountContext.accountDetails.accountNo, props.hash, "")
            } else {
                let imageData = props.image;
                                            
                // Check if image is a URL (http/https)
                if (props.image.startsWith('http://') || props.image.startsWith('https://')) {
                    try {
                        console.log('[CollectionImage] Converting URL to base64 for API call');
                        
                        // Fetch the image from the URL
                        const response = await fetch(props.image);
                        const blob = await response.blob();
                        
                        // Convert blob to base64
                        const reader = new FileReader();
                        imageData = await new Promise((resolve, reject) => {
                            reader.onloadend = () => {
                                // Remove the data:image/xxx;base64, prefix and return only base64 string
                                const base64String = reader.result.split(',')[1];
                                resolve(base64String);
                            };
                            reader.onerror = reject;
                            reader.readAsDataURL(blob);
                        });
                        
                        console.log('[CollectionImage] Successfully converted URL to base64');
                    } catch (error) {
                        console.error('[CollectionImage] Error converting URL to base64:', error);
                        // Fall back to using the original URL
                        return;
                    }
                }
                // If in Electron and image is a file path, read the file and convert to base64
                else if (electronBridge.isElectron && (props.image.includes('://') || props.image.includes(':\\'))) {
                    try {
                        const fs = window.require('fs');
                        const path = window.require('path');
                        
                        // Clean up the file path (remove file:// prefix if present)
                        let filePath = props.image;
                        if (filePath.startsWith('file://')) {
                            filePath = filePath.replace('file://', '');
                        }
                        if (filePath.startsWith('safe-file://')) {
                            filePath = decodeURI(filePath.replace('safe-file://', ''));
                        }
                        
                        // Read the file as buffer
                        const buffer = fs.readFileSync(filePath);
                        
                        // Convert buffer to base64
                        imageData = buffer.toString('base64');
                        
                        console.log('[CollectionImage] Converted file to base64 for useImage');
                    } catch (error) {
                        console.error('[CollectionImage] Error reading file for useImage:', error);
                        // Fall back to using the original path
                        imageData = props.image;
                    }
                }

                imageDescription = getImageDescription(accountContext.accountDetails.accountNo, "", imageData)
            }
            
            imageDescription.then((description) => {
                console.log(description)
                if (description.image_description !== undefined) {
                    imageDescription = description.image_description;

                    if (imageDescription.length > 0) {
                        setImageDescription(imageDescription);
                        setImageDescriptionLoading(false);
                        db.imageDescriptions.put({
                            hash: props.hash,
                            description: imageDescription,
                            timestamp: Date.now()
                        });
                    }
                }
            });
        }
    }

    const makeImagePublic = async() => {
        console.log("[shareImageAction] Making image public/private");
        if (accountContext.accountDetails.alias !== "") {
            setVisibility("Public");
            console.log("Change Image Visibility Route: ", props.hash);
            await changeImageVisibility(accountContext.accountDetails.accountNo, props.hash, 1);
        } else {
            Swal.fire({
                title: "No Username",
                text: "You need to have an username in order to make your images available to the public. Please login in to the website and set yourself a username before proceeding.",
                icon: "error",
                confirmButtonText: "Ok",
                confirmButtonColor: "#FFB02E",
            }).then((result) => {
                if (result.isConfirmed) {
                    window.open("https://signup.promptus.ai/sign-in", "_blank");
                }
            });
        }
    };

    const shareImageAction = async (platform) => {
        console.log("[shareImageAction] started");

        // Check if props.image is already a shareable URL
        const isDirectUrl = props.image && (props.image.startsWith('http://') || props.image.startsWith('https://'));

        // if (isDirectUrl) {
        //     console.log("[shareImageAction] Using direct URL:", props.image);

        //     const shareConfig = {
        //         twitter: {
        //             width: 550,
        //             height: 420,
        //             baseUrl: 'https://twitter.com/intent/tweet',
        //             title: 'Share on Twitter'
        //         },
        //         facebook: {
        //             width: 626,
        //             height: 436,
        //             baseUrl: 'https://www.facebook.com/sharer/sharer.php',
        //             title: 'Share on Facebook'
        //         }
        //     };

        //     if (!(platform in shareConfig)) {
        //         console.error(`[shareImageAction] Unsupported platform: ${platform}`);
        //         return;
        //     }

        //     const shareContent = {
        //         url: props.image,
        //         text: `Check out this AI-generated image on Promptus!`,
        //         hashtags: 'AI,Promptus,AIArt',
        //         via: 'promptus_ai'
        //     };

        //     const config = shareConfig[platform];
        //     let shareWindowUrl = platform === 'twitter'
        //         ? `${config.baseUrl}?text=${encodeURIComponent(shareContent.text)}&url=${encodeURIComponent(shareContent.url)}&hashtags=${encodeURIComponent(shareContent.hashtags)}&via=${shareContent.via}`
        //         : `${config.baseUrl}?u=${encodeURIComponent(shareContent.url)}`;

        //     const windowFeatures = {
        //         width: config.width,
        //         height: config.height,
        //         left: (window.screen.width / 2) - (config.width / 2),
        //         top: (window.screen.height / 2) - (config.height / 2)
        //     };

        //     const windowFeaturesString = Object.entries(windowFeatures)
        //         .map(([key, value]) => `${key}=${value}`)
        //         .join(',');

        //     if (electronBridge.isElectron) {
        //         electronBridge.ipcRenderer.send('open-urlInExternal', shareWindowUrl);
        //     } else {
        //         window.open(shareWindowUrl, config.title, windowFeaturesString);
        //     }

        //     console.log("[shareImageAction] Share window opened for direct URL");
        //     return;
        // }

        // Initialize loading popup
        const loadingPopup = Swal.fire({
            title: 'Processing',
            html: 'Adding to collection...',
            allowOutsideClick: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            if (accountContext.loggedIn === false) {
                loadingPopup.close();
                Swal.fire({
                    title: "Not Logged In",
                    text: "You need to be logged in to add images to your collection. Please login to your account to proceed.",
                    icon: "error",
                    confirmButtonText: "Ok",
                    confirmButtonColor: "#FFB02E",
                }).then((result) => {
                    if (result.isConfirmed) {
                        navigate('/profile')
                    }
                });
                return;
            }

            await db.settings.put({ key: 'toggleLock', value: true });

            try {
                Swal.update({ html: 'Uploading image for sharing...' });
                console.log("[shareImageAction] Uploading image for sharing");

                const collectionImage = await getSpecificImage(props.uid);
                const colArr = collectionImage ? [collectionImage] : null;
                console.log("[shareImageAction] Collection image found:", !!collectionImage);

                let imageArr = [{
                    uid: props.uid,
                    image: props.image,
                    seed: props.seed,
                    model: props.model,
                    hash: props.hash,
                    online: props.online,
                    tag: props.tag,
                    prompt: promptInfo.prompt,
                }];

                let uploadResult;
                if (electronBridge.isElectron && props.image.includes(':\\')) {
                    const tokens = getAuthorizationToken();
                    const devAPI = await getUseDepApi();
                    uploadResult = await electronBridge.ipcRenderer.invoke('collection_upload', JSON.stringify(imageArr), accountContext.accountDetails.accountNo, null, colArr, tokens, devAPI);
                } else {
                    uploadResult = await updateAccount(JSON.stringify(imageArr), accountContext.accountDetails.accountNo, null, colArr);
                }

                console.log("[shareImageAction] Upload result:", uploadResult);

                if (!uploadResult?.url) {
                    throw new Error('Failed to get share URL from upload');
                }

                const shareUrl = uploadResult.url;
                console.log("[shareImageAction] Share URL:", shareUrl);

                Swal.update({ html: 'Opening share dialog...' });

                const shareConfig = {
                    twitter: {
                        width: 550,
                        height: 420,
                        baseUrl: 'https://twitter.com/intent/tweet',
                        title: 'Share on Twitter'
                    },
                    facebook: {
                        width: 626,
                        height: 436,
                        baseUrl: 'https://www.facebook.com/sharer/sharer.php',
                        title: 'Share on Facebook'
                    }
                };

                if (!(platform in shareConfig)) {
                    throw new Error(`Unsupported platform: ${platform}`);
                }

                const shareContent = {
                    url: shareUrl,
                    text: `Check out this AI-generated image on Promptus!`,
                    hashtags: 'AI,Promptus,AIArt',
                    via: 'promptus_ai'
                };

                const config = shareConfig[platform];
                let shareWindowUrl = platform === 'twitter'
                    ? `${config.baseUrl}?text=${encodeURIComponent(shareContent.text)}&url=${encodeURIComponent(shareContent.url)}&hashtags=${encodeURIComponent(shareContent.hashtags)}&via=${shareContent.via}`
                    : `${config.baseUrl}?u=${encodeURIComponent(shareContent.url)}`;

                const windowFeatures = {
                    width: config.width,
                    height: config.height,
                    left: (window.screen.width / 2) - (config.width / 2),
                    top: (window.screen.height / 2) - (config.height / 2)
                };

                const windowFeaturesString = Object.entries(windowFeatures)
                    .map(([key, value]) => `${key}=${value}`)
                    .join(',');

                if (electronBridge.isElectron) {
                    electronBridge.ipcRenderer.send('open-urlInExternal', shareWindowUrl);
                } else {
                    const shareWindow = window.open(
                        shareWindowUrl,
                        config.title,
                        windowFeaturesString
                    );

                    if (!shareWindow) {
                        throw new Error('Popup was blocked');
                    }
                }

                loadingPopup.close();
            } finally {
                await db.settings.put({ key: 'toggleLock', value: false });
            }

        } catch (error) {
            console.error('Error in shareImageAction:', error);
            loadingPopup.close();
            Swal.fire({
                title: "Error",
                html: error.message === 'Popup was blocked'
                    ? "<p>Please allow popups to share this content</p>"
                    : "<p>Sorry, there was an error sharing the image. To share an image it needs to be in My Collection. Click on the below icon to add to My Collection</p> " +
                    "<div id=\"svg-container\" style=\"cursor: pointer;width:12%;margin-left: auto;margin-right: auto\"><!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\n" +
                    "\n" +
                    "<!-- Uploaded to: SVG Repo, www.svgrepo.com, Transformed by: SVG Repo Mixer Tools -->\n" +
                    "<svg width=\"64px\" height=\"64px\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" stroke=\"#000080\">\n" +
                    "\n" +
                    "    <g id=\"SVGRepo_bgCarrier\" stroke-width=\"0\"/>\n" +
                    "\n" +
                    "    <g id=\"SVGRepo_tracerCarrier\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                    "\n" +
                    "    <g id=\"SVGRepo_iconCarrier\">\n" +
                    "        <path d=\"M21 17.5C21 19.433 19.433 21 17.5 21C15.567 21 14 19.433 14 17.5C14 15.567 15.567 14 17.5 14C19.433 14 21 15.567 21 17.5Z\" stroke=\"#000080\" stroke-width=\"1.5\"/>\n" +
                    "        <path d=\"M2 11H22\" stroke=\"#000080\" stroke-width=\"1.5\" stroke-linecap=\"round\"/>\n" +
                    "        <path d=\"M4 11L4.6138 8.54479C5.15947 6.36211 5.43231 5.27077 6.24609 4.63538C7.05988 4 8.1848 4 10.4347 4H13.5653C15.8152 4 16.9401 4 17.7539 4.63538C18.5677 5.27077 18.8405 6.36211 19.3862 8.54479L20 11\" stroke=\"#000080\" stroke-width=\"1.5\" stroke-linecap=\"round\"/>\n" +
                    "        <path d=\"M10 17.5C10 19.433 8.433 21 6.5 21C4.567 21 3 19.433 3 17.5C3 15.567 4.567 14 6.5 14C8.433 14 10 15.567 10 17.5Z\" stroke=\"#000080\" stroke-width=\"1.5\"/>\n" +
                    "        <path d=\"M10 17.4999L10.6584 17.1707C11.5029 16.7484 12.4971 16.7484 13.3416 17.1707L14 17.4999\" stroke=\"#000080\" stroke-width=\"1.5\" stroke-linecap=\"round\"/>\n" +
                    "    </g>\n" +
                    "\n" +
                    "</svg></div>" ,
                icon: "error",
                confirmButtonText: "Ok",
                confirmButtonColor: "#FFB02E",
                didOpen: () => {
                    const svgContainer = document.getElementById('svg-container');
                    if (svgContainer) {
                        svgContainer.addEventListener('click', () => {
                            handlePrivatePublic();
                        });
                    }
                }
            });

            try {
                await db.settings.put({ key: 'toggleLock', value: false });
            } catch (lockError) {
                console.error('Error releasing lock:', lockError);
            }
        }
    };

    const postToTwitter = async () => {
        //console.log(await(shareToSocialMedia(accountContext.accountDetails.accountNo, props.image, "twitter")))
        console.log("In Progress");
    };

    // Handle send to MoMM
    // Handle opening file in explorer
    const handleViewInExplorer = async () => {
        try {
            if (!electronBridge.isElectron) {
                console.warn('View in explorer is only available in the desktop app');
                return;
            }
            
            // Check if image is a file path
            if (props.image && (props.image.includes(':\\') || props.image.includes('://'))) {
                console.log('Opening file location:', props.image);
                
                // Clean up the file path (remove file:// prefix if present)
                let filePath = props.image;
                if (filePath.startsWith('file://')) {
                    filePath = filePath.replace('file:///', '').replace('file://', '');
                    // Handle URL encoded characters if any
                    filePath = decodeURIComponent(filePath);
                }
                
                // Use IPC to request main process to open and focus the explorer
                // This allows the main process to use additional APIs for focusing
                if (electronBridge.ipcRenderer) {
                    electronBridge.ipcRenderer.invoke('show-item-in-folder', filePath);
                } else {
                    // Fallback to direct shell module if IPC not available
                    const { shell } = window.require('electron');
                    shell.showItemInFolder(filePath);
                    
                    // Try to bring focus using exec command on Windows
                    const { exec } = window.require('child_process');
                    const path = window.require('path');
                    
                    // On Windows, use explorer with /select flag which should bring focus
                    if (process.platform === 'win32') {
                        const normalizedPath = path.normalize(filePath);
                        exec(`explorer.exe /select,"${normalizedPath}"`, (error) => {
                            if (error) {
                                console.error('Error focusing explorer:', error);
                            }
                        });
                    }
                }
            }
        } catch (error) {
            console.error('Error opening file in explorer:', error);
            Swal.fire({
                title: "Error",
                text: "Unable to open file location",
                icon: "error",
                confirmButtonText: "Ok",
                confirmButtonColor: "#FFB02E",
            });
        }
    };

    const handleSendToMoMM = async () => {
        try {
            console.log(':outbox_tray: CollectionImage: Starting send to MOMM...', {
                hasImage: !!props.image,
                imageLength: props.image ? props.image.length : 0,
                imageFirstChars: props.image ? props.image.substring(0, 50) : 'none',
                uid: props.uid,
                hash: props.hash,
                isMyCollection: props.isMyCollection,
                dataType: props.dataType,
                allProps: Object.keys(props)
            });
            // Validate image data
            if (!props.image) {
                console.error(':outbox_tray: CollectionImage: No image data available');
                throw new Error('No image data available');
            }
            if (typeof props.image !== 'string') {
                console.error(':outbox_tray: CollectionImage: Invalid image data type:', typeof props.image);
                throw new Error('Invalid image data format');
            }
            // Create a data URL - handle file paths, base64, and URL formats
            let imageDataUrl;
            // Check if it's a file path (Windows or Unix style)
            if (props.image.includes(':\\') || props.image.startsWith('/') || props.image.startsWith('./')) {
                console.log(':outbox_tray: CollectionImage: Detected file path, reading file...');
                try {
                    // Use electronBridge to read the file
                    if (electronBridge.isElectron) {
                        // Read file as base64 using Electron's fs module
                        const fs = window.require('fs');
                        const path = window.require('path');
                        // Normalize the path
                        const normalizedPath = path.normalize(props.image);
                        console.log(':outbox_tray: CollectionImage: Reading file from:', normalizedPath);
                        // Read the file as base64
                        const fileBuffer = fs.readFileSync(normalizedPath);
                        const base64Data = fileBuffer.toString('base64');
                        // Determine MIME type based on file extension
                        const ext = path.extname(normalizedPath).toLowerCase();
                        let mimeType = 'image/png'; // default
                        switch(ext) {
                            case '.jpg':
                            case '.jpeg':
                                mimeType = 'image/jpeg';
                                break;
                            case '.png':
                                mimeType = 'image/png';
                                break;
                            case '.gif':
                                mimeType = 'image/gif';
                                break;
                            case '.webp':
                                mimeType = 'image/webp';
                                break;
                            case '.bmp':
                                mimeType = 'image/bmp';
                                break;
                        }
                        imageDataUrl = `data:${mimeType};base64,${base64Data}`;
                        console.log(':outbox_tray: CollectionImage: Successfully converted file to base64');
                    } else {
                        throw new Error('File path reading is only supported in Electron app');
                    }
                } catch (fileError) {
                    console.error(':outbox_tray: CollectionImage: Error reading file:', fileError);
                    throw new Error(`Failed to read image file: ${fileError.message}`);
                }
            } else if (props.image.startsWith('http://') || props.image.startsWith('https://')) {
                // Image is already a URL (e.g., from MOMM videos/images)
                imageDataUrl = props.image;
                console.log(':outbox_tray: CollectionImage: Using URL directly');
            } else if (props.image.startsWith('data:')) {
                // Image is already a data URL
                imageDataUrl = props.image;
                console.log(':outbox_tray: CollectionImage: Using existing data URL');
            } else {
                // Assume it's base64 data
                imageDataUrl = `data:image/png;base64,${props.image}`;
                console.log(':outbox_tray: CollectionImage: Creating data URL from base64');
            }
            // Get the simplest possible version of prompt info
            let promptText = '';
            console.log(':outbox_tray: CollectionImage: Extracting prompt...', {
                propsPromptType: typeof props.prompt,
                promptInfoType: typeof promptInfo,
                hasPropsPrompt: !!props.prompt,
                hasPromptInfo: !!promptInfo
            });
            // Simple, direct prompt extraction with minimal processing
            if (typeof props.prompt === 'string' && props.prompt) {
                promptText = props.prompt;
                console.log(":outbox_tray: CollectionImage: Using props.prompt (string)");
            } else if (typeof promptInfo === 'string' && promptInfo) {
                promptText = promptInfo;
                console.log(":outbox_tray: CollectionImage: Using promptInfo (string)");
            } else if (props.prompt && typeof props.prompt === 'object') {
                // Try to extract from object without async operations
                if (props.prompt.prompt && typeof props.prompt.prompt === 'string') {
                    promptText = props.prompt.prompt;
                    console.log(":outbox_tray: CollectionImage: Using props.prompt.prompt");
                }
            } else if (promptInfo && typeof promptInfo === 'object') {
                // Try to extract from promptInfo object
                if (promptInfo.prompt && typeof promptInfo.prompt === 'string') {
                    promptText = promptInfo.prompt;
                    console.log(":outbox_tray: CollectionImage: Using promptInfo.prompt");
                }
            }
            // Fallback text if nothing else
            if (!promptText) {
                promptText = `Image from ${props.isMyCollection ? 'My Collection' : 'Generate page'} (${props.uid || props.hash?.substring(0, 8) || 'Unknown ID'})`;
                console.log(":outbox_tray: CollectionImage: Using fallback prompt text");
            }
            console.log(":outbox_tray: CollectionImage: Final prompt:", promptText ? (promptText.length > 100 ? promptText.substring(0, 100) + '...' : promptText) : 'none');
            // Simplify the image data for MoMM - bare minimum required
            const imageData = {
                url: imageDataUrl,
                name: `${props.isMyCollection ? 'Collection' : 'Playground'} Image - ${props.uid || props.hash?.substring(0, 8) || 'Unknown ID'}`,
                prompt: promptText,
                fromPlayground: true
            };
            console.log(':outbox_tray: CollectionImage: Storing image data...', {
                name: imageData.name,
                promptLength: imageData.prompt.length,
                dataUrlLength: imageData.url.length
            });
            // Store in localStorage
            localStorage.setItem('momm_imported_image', JSON.stringify(imageData));
            // Verify storage
            const stored = localStorage.getItem('momm_imported_image');
            if (!stored) {
                throw new Error('Failed to store image data in localStorage');
            }
            console.log(':white_check_mark: CollectionImage: Image data stored successfully');
            // Show success message
            const successMessage = document.createElement('div');
            successMessage.style.position = 'fixed';
            successMessage.style.top = '20px';
            successMessage.style.right = '20px';
            successMessage.style.backgroundColor = '#10B981'; // Green
            successMessage.style.color = 'white';
            successMessage.style.padding = '12px 20px';
            successMessage.style.borderRadius = '8px';
            successMessage.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
            successMessage.style.zIndex = '9999';
            successMessage.style.transition = 'opacity 0.3s';
            successMessage.textContent = 'Image sent to MoMM! Redirecting...';
            document.body.appendChild(successMessage);
            // Navigate after short delay
            setTimeout(() => {
                // Fade out message
                successMessage.style.opacity = '0';
                setTimeout(() => {
                    // Remove message and navigate
                    if (document.body.contains(successMessage)) {
                        document.body.removeChild(successMessage);
                    }
                    console.log(':outbox_tray: CollectionImage: Navigating to MOMM...');
                    // Use React Router navigation for proper SPA behavior
                    navigate('/momm');
                }, 300);
            }, 1000);
            console.log(":white_check_mark: CollectionImage: SEND TO MOMM COMPLETE");
        } catch (err) {
            console.error(':outbox_tray: CollectionImage: Error in Send to MoMM function:', err);
            // Determine error message
            let errorMessage = 'Error sending image to MoMM';
            if (err.message) {
                errorMessage = `Error: ${err.message}`;
            }
            // Show error message
            const errorMessageDiv = document.createElement('div');
            errorMessageDiv.style.position = 'fixed';
            errorMessageDiv.style.top = '20px';
            errorMessageDiv.style.right = '20px';
            errorMessageDiv.style.backgroundColor = '#EF4444'; // Red
            errorMessageDiv.style.color = 'white';
            errorMessageDiv.style.padding = '12px 20px';
            errorMessageDiv.style.borderRadius = '8px';
            errorMessageDiv.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
            errorMessageDiv.style.zIndex = '9999';
            errorMessageDiv.textContent = errorMessage;
            document.body.appendChild(errorMessageDiv);
            // Remove error message after 5 seconds
            setTimeout(() => {
                if (document.body.contains(errorMessageDiv)) {
                    document.body.removeChild(errorMessageDiv);
                }
            }, 5000);
        }
    };

    const handlePromptClick = async () => {
        const promptDetails = await db.collection.where("uid").equals(props.uid).first();
        console.log("Prompt Details: ", promptDetails);
        
        if (promptDetails) {
            if (props.isMyCollection) {
                props.setUid(props.prompt)
            } else {
                props.setUid(props.uid)
            }
        } else {
            console.log("No record found for uid:", props.uid, props.prompt);
            props.setPrompt(props.hash)
        }

    }

    const handleEscapeKey = (e) => {
        console.log("Key pressed: ", e);
        
        if (e.key === "Escape") {
            setZoomedImage(null)
        }
    }

    useEffect(() => {
        if (zoomedImage) {
            window.addEventListener('keydown', handleEscapeKey);
        }

        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener('keydown', handleEscapeKey);
        };
    }, [zoomedImage]);

    const handlePromptPopulation = () => {
        populatePromptField(imageDescription, updatePrompt)
        setOpenDescribeImage(false)
    }

    const getAllImageFields = () => {
        const fields = [];

        for (const [key, field] of Object.entries(currentSchema)) {
            if (field.type === 'url' && field.image_upload === true) {
                fields.push({ key, field, shouldUseUrl: true });
            }
        }

        for (const [key, field] of Object.entries(currentSchema)) {
            if (field.type === 'b64data' && field.url_allowed === true) {
                if (!fields.some(f => f.key === key)) {
                    fields.push({ key, field, shouldUseUrl: true });
                }
            }
        }

        for (const [key, field] of Object.entries(currentSchema)) {
            if (field.type === 'file' || field.type === 'b64' ||
                field.type === 'b64data' || field.type === 'image' ||
                field.type === 'IMAGE' ||
                (field.accept && field.accept.includes('image'))) {
                if (!fields.some(f => f.key === key)) {
                    fields.push({ key, field, shouldUseUrl: false });
                }
            }
        }

        fields.sort((a, b) => (b.field.importance || 0) - (a.field.importance || 0));
        return fields;
    };

    const getTargetFieldInfo = () => {
        const fields = getAllImageFields();
        if (fields.length === 0) return { targetField: null, shouldUseUrl: false };
        return { targetField: { key: fields[0].key, field: fields[0].field }, shouldUseUrl: fields[0].shouldUseUrl };
    };

    const prepareImageData = async (shouldUseUrl) => {
        let imageData = props.image;
        const isImageUrl = props.image.startsWith('http://') || props.image.startsWith('https://');

        if (shouldUseUrl && isImageUrl) {
            imageData = props.image;
        } else if (shouldUseUrl && !isImageUrl && props.uid && props.hash) {
            if (props.url) {
                imageData = props.url;
            } else {
                try {
                    const result = await getGenerateOutput(props.uid, props.hash);
                    if (result.url && result.url.trim() !== '') {
                        imageData = result.url;
                        if (!electronBridge.isElectron) {
                            try {
                                await db.images.where('hash').equals(props.hash).modify({ image: result.url });
                                await db.collectedImages.where('hash').equals(props.hash).modify({ image: result.url });
                                setLocalImageOverride(result.url);
                            } catch (dbError) {
                                console.error('[CollectionImage] Error updating IndexedDB with URL:', dbError);
                            }
                        }
                    }
                } catch (error) {
                    console.error('[CollectionImage] Error fetching URL from API:', error);
                }
            }
        } else {
            if (props.image.startsWith('http://') || props.image.startsWith('https://')) {
                try {
                    const response = await fetch(props.image);
                    const blob = await response.blob();
                    const reader = new FileReader();
                    imageData = await new Promise((resolve, reject) => {
                        reader.onloadend = () => {
                            const base64String = reader.result.split(',')[1];
                            resolve(base64String);
                        };
                        reader.onerror = reject;
                        reader.readAsDataURL(blob);
                    });
                } catch (error) {
                    console.error('[CollectionImage] Error converting URL to base64:', error);
                    return null;
                }
            } else if (electronBridge.isElectron && (props.image.includes('://') || props.image.includes(':\\'))) {
                try {
                    const fs = window.require('fs');
                    let filePath = props.image;
                    if (filePath.startsWith('file://')) {
                        filePath = filePath.replace('file://', '');
                    }
                    if (filePath.startsWith('safe-file://')) {
                        filePath = decodeURI(filePath.replace('safe-file://', ''));
                    }
                    const buffer = fs.readFileSync(filePath);
                    imageData = buffer.toString('base64');
                } catch (error) {
                    console.error('[CollectionImage] Error reading file for useImage:', error);
                    imageData = props.image;
                }
            }
        }
        return imageData;
    };

    const handleUseImage = async () => {
        const allFields = getAllImageFields();

        if (allFields.length === 0) {
            console.warn('[CollectionImage] No suitable image field found in current schema');
            return;
        }

        let chosen = allFields[0];

        if (allFields.length > 1) {
            const buttonsHtml = allFields.map((f, i) => {
                const label = f.field.label || f.field.title || f.key;
                const typeLabel = f.shouldUseUrl ? 'URL' : 'File';
                return `<button data-field-key="${f.key}" class="swal-field-btn" style="
                    display:flex; align-items:center; gap:10px; width:100%; padding:12px 16px;
                    background:${i === 0 ? '#2A1B83' : '#190A4E'}; border:2px solid ${i === 0 ? '#FFB02E' : '#34206D'};
                    border-radius:10px; color:white; cursor:pointer; transition:all 0.2s; text-align:left;
                    font-family:'Titillium Web',sans-serif; font-size:14px;
                ">
                    <span style="display:flex;align-items:center;justify-content:center;width:32px;height:32px;border-radius:8px;background:#34206D;flex-shrink:0;">
                        <svg width="16" height="16" fill="#FFB02E" viewBox="0 0 20 20"><path d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z"/></svg>
                    </span>
                    <span style="flex:1;">
                        <span style="display:block;font-weight:600;color:#FFB02E;">${label}</span>
                        <span style="display:block;font-size:11px;color:#9CA3AF;margin-top:2px;">${typeLabel} input</span>
                    </span>
                </button>`;
            }).join('');

            const result = await Swal.fire({
                title: 'Which input field?',
                html: `<div style="display:flex;flex-direction:column;gap:8px;margin-top:8px;">${buttonsHtml}</div>`,
                showConfirmButton: false,
                showCancelButton: true,
                cancelButtonText: 'Cancel',
                cancelButtonColor: '#d33',
                background: '#190A4E',
                color: '#ffffff',
                didOpen: (popup) => {
                    popup.querySelectorAll('.swal-field-btn').forEach(btn => {
                        btn.addEventListener('mouseenter', () => {
                            btn.style.borderColor = '#FFB02E';
                            btn.style.background = '#2A1B83';
                        });
                        btn.addEventListener('mouseleave', () => {
                            btn.style.borderColor = '#34206D';
                            btn.style.background = '#190A4E';
                        });
                        btn.addEventListener('click', () => {
                            Swal.close({ isConfirmed: true, value: btn.dataset.fieldKey });
                        });
                    });
                }
            });

            if (result.isDismissed) return;
            chosen = allFields.find(f => f.key === result.value) || allFields[0];
        }

        console.log(`[CollectionImage] Target field: ${chosen.key}, shouldUseUrl: ${chosen.shouldUseUrl}`);

        const imageData = await prepareImageData(chosen.shouldUseUrl);
        if (imageData === null) return;

        eventBus.emit('useImage', {
            image: imageData,
            uid: props.uid,
            targetFieldKey: chosen.key
        });
    }

    // Enhanced image source determination with validation
    // Use localImageOverride if set (e.g., after fetching URL from API), otherwise use props.image
    const imageSource = localImageOverride || props.image;
    let imageSrc;
    if (electronBridge.isElectron && imageSource && imageSource.includes(":\\")) {
        // Electron environment and file path (Windows or Unix)
        // imageSrc = toFileUrl(imageSource);
        imageSrc = imageSource
    } else if (imageSource && imageSource.startsWith('http')) {
        // Remote URL
        imageSrc = imageSource;
    } else if (imageSource) {
        // Assume base64 - validate it's not truncated
        if (imageSource.length > 0) {
            // Check if base64 string appears complete (should end with valid base64 chars)
            const base64Pattern = /^[A-Za-z0-9+/]*={0,2}$/;
            const lastChars = imageSource.slice(-4);
            if (!base64Pattern.test(lastChars) && !imageSource.endsWith('=')) {
                console.warn('Base64 image may be truncated:', props.uid, 'Last chars:', lastChars);
            }
            imageSrc = `data:image/png;base64,${imageSource}`;
        } else {
            console.error('Empty image data for:', props.uid);
            imageSrc = null;
        }
    }
    
    // Image error handler with retry logic
    const handleImageError = (e) => {
        console.error('Image failed to load:', props.uid, 'Retry count:', retryCount, 'URL:', imageSrc?.substring(0, 100));
        
        if (retryCount < 3 && props.image && props.image.startsWith('http')) {
            // Retry for URL images
            setTimeout(() => {
                setRetryCount(prev => prev + 1);
                setImageLoadError(false);
                // Force re-render by updating a dummy state
                e.target.src = imageSrc + (imageSrc.includes('?') ? '&' : '?') + 'retry=' + (retryCount + 1);
            }, 1000 * (retryCount + 1)); // Exponential backoff
        } else {
            setImageLoadError(true);
            setImageLoading(false);
        }
    };
    
    const handleImageLoad = () => {
        setImageLoading(false);
        setImageLoadError(false);
        setRetryCount(0);
    };
    // const filePath = props.image.replace(/\\/g, "/");

//     const imageSrc = filePath && filePath.includes(":\\")
//   ? `file://${filePath}`  // replace \ with /
//   : `data:image/png;base64,${props.image}`;

    return (
        <>
            {failedImage ?
                <div className={`group w-full rounded-xl ${imageRegenerating ? 'pointer-events-none opacity-90' : null} overflow-hidden relative bg-gray-500 ${imageRegenerating ? 'animate-pulse' : ''}`}>
                    <img className={"w-full h-full object-contain opacity-80"} src="https://i.postimg.cc/632gRsSp/Final-logo-Black.png" alt='Help'/>
                    {imageRegenerating ?
                        null
                    :
                        <>
                            <button className={"absolute top-0 right-0 rounded-tr-lg bg-red-600 p-2"} title="Delete Image" onClick={deleteImage}>
                                <CardRemove alt={"Remove Icon"} />
                            </button>
                            <button 
                                className={"absolute bottom-0 right-0 rounded-br-lg bg-dark-blue p-2"} 
                                title="Populate Prompt" 
                                onClick={getPromptForImage}
                            >
                                <CardPaste alt={"Populate Prompt Icon"} className="w-5 h-5" />
                            </button>
                            {props.viewFailedImage && (
                                <button className={"absolute top-0 left-0 rounded-tl-lg bg-dark-blue p-2"} title="View Details" onClick={viewDetails}>
                                    <CardEye alt={"View Details Icon"} />
                                </button>
                            )}
                            <button className={`absolute top-[40%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 rounded-lg bg-yellow text-nowrap py-2 px-3 shadow-md font-bold text-m uppercase w-fit`} onClick={() => regenerateImage(false)}>Regenerate Image</button>
                            <button className={`absolute top-2/3 left-1/2 transform -translate-x-1/2 -translate-y-1/2 rounded-lg bg-yellow text-nowrap py-2 px-3 shadow-md font-bold text-sm uppercase w-fit`} onClick={() => regenerateImage(true)}>Regenerate Workload</button>
                        </>             
                    }
                </div>
            :    
                <>
                    <div className="group relative w-fit mx-auto" ref={setImageRef}>
                        {/* Mobile Menu Button - Always visible on mobile */}
                        {isMobile && (
                            <button
                                ref={menuButtonRef}
                                onClick={() => setShowMobileToolbar(!showMobileToolbar)}
                                className="absolute top-2 right-2 z-20 bg-dark-blue/80 backdrop-blur p-2 rounded-lg shadow-lg"
                                title="Show options"
                            >
                                <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                                    <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
                                </svg>
                            </button>
                        )}
                        
                        {/* Toolbar - Desktop: hover, Mobile: click toggle */}
                        <div 
                            ref={toolbarRef}
                            className={`${
                                isMobile 
                                    ? (showMobileToolbar ? 'visible opacity-100' : 'invisible opacity-0')
                                    : 'invisible group-hover:visible opacity-0 group-hover:opacity-100'
                            } transition-all duration-200 absolute -top-5 z-10 ${isSmallImage ? 'left-1/2 transform -translate-x-1/2' : 'left-0 right-0'}`}>
                            <div className={`bg-dark-blue/90 backdrop-blur flex flex-row flex-wrap ${showSaveDialog ? 'flex-wrap' : ''} justify-center self-center p-2 rounded gap-2 shadow-lg ${isSmallImage ? 'min-w-[300px] small-image-toolbar' : 'w-full'}`}>
                                <div className={"flex flex-wrap gap-2 w-full px-2 justify-center"}>
                                    {!props.isMyCollection ?
                                        <button className={"w-8 h-8 flex items-center justify-center hover:bg-dark-blue/50 rounded-lg transition"} onClick={toggleCollection} title={`${props.inCollection ? "Remove from Collection" : "Add to Collection"}`}>
                                            {localInCollection ?
                                                <CardInCollection alt={"In Collection Icon"} className="w-5 h-5"/> 
                                            :
                                                <CardAdd alt={"Add to Collection Icon"} className="w-5 h-5"/>
                                            }
                                        </button> :
                                        <>
                                            <button className={"w-8 h-8 flex items-center justify-center hover:bg-dark-blue/50 rounded-lg transition"} onClick={toggleCollection} title="Remove from Collection">
                                                <CardInCollection alt={"In Collection Icon"} className="w-5 h-5"/>
                                            </button>
            
                                            <button title={`${privateImage ? 'Make the image public': 'Make the image private'}`} className={"w-8 h-8 flex items-center justify-center hover:bg-dark-blue/50 rounded-lg transition"} onClick={handlePrivatePublic}>
                                            {privateImage ?
                                                <CardPrivate alt="Private Icon" className="w-5 h-5"/> 
                                            :
                                                <CardPublic alt="Public Icon" className="w-5 h-5"/>
                                            }
                                            </button>
                                        </>
                                    }
                                    <button title="Examine Image" className={"w-8 h-8 flex items-center justify-center hover:bg-dark-blue/50 rounded-lg transition"} onClick={() => setZoomedImage({image: props.image, seed: props.seed, tag: tag, hash: props.hash, id: props.id})}>
                                        <CardZoom alt={"Zoom Icon"} className="w-5 h-5"/>
                                    </button>
                                    <button title="Edit Image" className={"w-8 h-8 flex items-center justify-center hover:bg-dark-blue/50 rounded-lg transition"} onClick={() => props.setZoomedImage({image: props.image, seed: props.seed})}>
                                        <CardEdit alt={"Edit Icon"} className="w-5 h-5"/>
                                    </button>
                                    <button title="Copy Image" className={"w-8 h-8 flex items-center justify-center hover:bg-dark-blue/50 rounded-lg transition"} onClick={copyImageToClipboard}>
                                        <CardCopy alt={"Copy Icon"} className="w-5 h-5"/>
                                    </button>
                                    <button title="Save Image" className={"w-8 h-8 flex items-center justify-center hover:bg-dark-blue/50 rounded-lg transition"} onClick={() => setShowSaveDialog(!showSaveDialog)}>
                                        <CardSave alt={"Save Icon"} className="w-5 h-5"/>
                                    </button>
                                    {props.setUid && props.setImage && hasImageField ?
                                        <button title="Use Image" className={"w-8 h-8 flex items-center justify-center hover:bg-dark-blue/50 rounded-lg transition"} onClick={handleUseImage}>
                                            <UploadIconWhite alt={"Use Image"} className="w-7 h-7"/>
                                        </button>
                                        : null}
                                    {/* Send to MoMM button - only show in Electron */}
                                    <button 
                                        title="Send to MoMM for AI iteration"
                                        className="w-8 h-8 flex items-center justify-center hover:bg-purple-600/70 bg-purple-700/50 rounded-lg transition"
                                        onClick={handleSendToMoMM}
                                    >
                                        <MOMMIcon />
                                    </button>
                                    {/* {electronBridge.isElectron && (
                                    )} */}
                                    <button title="Share Image" className={"w-8 h-8 flex items-center justify-center hover:bg-dark-blue/50 rounded-lg transition"}
                                            onClick={() => setshowShareImageDialog(!showShareImageDialog)}>
                                        <CardShare alt="Share Icon" className="w-5 h-5"/>
                                    </button>
                                    <button title="Tag Image" className={"w-8 h-8 flex items-center justify-center hover:bg-dark-blue/50 rounded-lg transition"} onClick={handleTagging}>
                                        <CardTag alt={"Tag Icon"} className="w-5 h-5"/>
                                    </button>
                                    <button title="Describe Image" className={"w-8 h-8 flex items-center justify-center hover:bg-dark-blue/50 rounded-lg transition"} onClick={handleDescribeImage}>
                                        <CardImageDescribe alt={"Describe Icon"} className="w-5 h-5"/>
                                    </button>
                                    <button title="Delete Image" className={"w-8 h-8 flex items-center justify-center hover:bg-dark-blue/50 rounded-lg transition"} onClick={deleteImage}>
                                        <CardRemove alt={"Remove Icon"} className="w-5 h-5"/>
                                    </button>
                                </div>
                                {showSaveDialog ?
                                    <div className="w-full flex flex-col gap-2 bg-dark-blue/90 backdrop-blur p-2 rounded-b">
                                        <input type={"text"} className={"w-full rounded text-dark-blue p-2 text-sm"}
                                            onChange={(e) => setDownloadName(e.target.value)} value={downloadName}
                                            onFocus={(e) => e.target.select()}
                                        />
                                        <div className="w-full flex flex-row justify-center gap-4">
                                            <button className="bg-dark-blue/40 rounded-lg px-4 py-2 hover:bg-dark-blue transition" onClick={() => downloadImage('image/png', 'png')}>.png</button>
                                            <button className="bg-dark-blue/40 rounded-lg px-4 py-2 hover:bg-dark-blue transition" onClick={() => downloadImage('image/webp', 'webp')}>.webp</button>
                                            <button className="bg-dark-blue/40 rounded-lg px-4 py-2 hover:bg-dark-blue transition" onClick={downloadPrompt}>.prompt</button>
                                        </div>
                                    </div>
                                    : null
                                }
                            </div>
                            {showShareImageDialog ?
                                <div className={"flex flex-row justify-center gap-4 p-2 bg-dark-blue/90 backdrop-blur rounded-b"}>
                                    <button className={"bg-dark-blue/40 rounded-lg px-4 py-2 hover:bg-dark-blue transition"} onClick={() => shareImageAction('facebook')}>Facebook</button>
                                    <button className={"bg-dark-blue/40 rounded-lg px-4 py-2 hover:bg-dark-blue transition"} onClick={() => shareImageAction('twitter')}>Twitter</button>
                                </div>
                                : null
                            }    
                        </div>
                        {/* Image Container */}
                        <div className={`w-full aspect-square rounded-xl overflow-hidden relative border-4 bg-black ${borderColor} ${!props.isMyCollection ? 'transition-all duration-300 group-hover:scale-105 group-hover:border-yellow' : ''}`} onClick={handleDblClick} draggable={"true"} onDragStart={handleDragStart}>
                            {imageLoadError ? (
                                <div className="w-full h-full flex items-center justify-center bg-gray-700">
                                    <div className="text-center p-4">
                                        <svg className="w-12 h-12 mx-auto mb-2 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                        </svg>
                                        <p className="text-sm text-gray-300">Failed to load image</p>
                                        {props.image && props.image.startsWith('http') && retryCount < 3 && (
                                            <button 
                                                onClick={() => {
                                                    setRetryCount(0);
                                                    setImageLoadError(false);
                                                    setImageLoading(true);
                                                }}
                                                className="mt-2 px-3 py-1 bg-blue-600 text-white rounded text-xs hover:bg-blue-700"
                                            >
                                                Retry
                                            </button>
                                        )}
                                    </div>
                                </div>
                            ) : (
                                <>
                                    {imageLoading && (
                                        <div className="absolute inset-0 flex items-center justify-center bg-gray-800">
                                            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white"></div>
                                        </div>
                                    )}
                                    <img
                                        className={"w-full h-full object-contain"}
                                        src={imageSrc}
                                        alt={`Generated image: ${ props.seed }`}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            props.onOpen?.();
                                        }}
                                        onLoad={handleImageLoad}
                                        // onError={handleImageError}
                                        loading="lazy"
                                    />
                                </>
                            )}
                            {/* View Details Icon & Seed - Bottom Left on Hover */}
                            <div className="absolute bottom-0 left-0 opacity-0 group-hover:opacity-100 transition-opacity duration-200 flex flex-row items-center bg-dark-blue/70 w-full">
                                {props.viewFailedImage && (
                                    <button 
                                        className={"hover:bg-dark-blue/90 p-2 transition border-r-2"} 
                                        title="View Details" 
                                        onClick={viewDetails}
                                    >
                                        <CardEye alt={"View Details Icon"} className="w-5 h-5" />
                                    </button>
                                )}
                                {props.seed ? (
                                    <span 
                                        className="text-sm font-base px-2 py-2 cursor-pointer text-center hover:text-yellow transition w-full"
                                        onClick={() => props.setSeed(props.seed)}
                                    >
                                        #{props.seed}
                                    </span>
                                )
                                :
                                    <div className="w-full opacity-0">

                                    </div>
                                }
                                <button 
                                    className={"hover:bg-dark-blue/90 p-2 transition border-l-2"} 
                                    title="Populate Prompt" 
                                    onClick={getPromptForImage}
                                >
                                    <CardPaste alt={"Populate Prompt Icon"} className="w-5 h-5" />
                                </button>
                            </div>
                            {props.isMyCollection ?
                                <div className={`absolute group-hover:hidden top-0 left-0 rounded px-3 py-2 bg-dark-blue text-base`}>{visibility}</div>
                            :
                                null    
                            }
                            {props.model ?
                                <div className={`absolute group-hover:hidden top-0 right-0 rounded px-3 py-2 bg-dark-blue/60 text-xs mobile:text-base truncate max-w-[50%]`}>{props.model}</div>
                            :
                                null
                            }
                            {tag ? 
                                <div className={`absolute group-hover:hidden bottom-0 left-0 rounded px-3 py-2 bg-dark-blue/40 text-sm`}>{tag}</div>
                            :
                                null
                            }
                            <div className={`absolute group-hover:hidden bottom-0 right-0 rounded px-3 py-2 bg-dark-blue/40 text-sm`}>{dimensions}</div>
                                <Modal open={openShare} onClose={() => setShare(false)} center container={document.querySelector('.main-content')}>
                                    <h2 className="text-2xl mb-5 font-bold">Share this Image</h2>
                                    <div className="modal-body">
                                        <p>Choose a platform to share this image:</p>
                                        <div className="mt-10 text-center">
                                            <a onClick={postToTwitter}>Post to Twitter</a>

                                        </div>
                                    </div>
                                </Modal>
                        </div>
                    </div>
                    <Modal open={open} onClose={() => setOpen(false)} center container={document.querySelector('.main-content')}>
                        <h2 className="text-2xl mb-5 font-bold">Category</h2>
                        <p>
                            Edit the tags you would like to add with the image
                        </p>
                        <div className="flex flex-row items-center justify-between my-5">
                            <p className="place-content-start">Original Tag: <span className="font-bold">{tag}</span></p>
                            <div id="clearTags" className={"flex flex-row items-center place-content-end"}>
                            <ToggleInput id={"clearTags"} onChange={() => handleClearTag()}/>
                            <label htmlFor={"clearTags"} className={`inline-block ml-2 text-sm font-medium ${clearTags ? 'text-yellow' : 'text-dark-blue'} transition`}>Clear Tags?</label>
                            </div>
                        </div>
                        <div className={"p-5 my-5 border border-dark-blue rounded-lg"}>
                            <label className="block mb-2 text-sm font-medium" htmlFor="existing">Existing Category</label>
                            {/* <select name="existing" className={"rounded-lg text-dark-blue border border-dark-blue p-2 w-2/5"} value={tag} onChange={(=> setTag(e.target.value)}>
                                <option value={`${props.tag}`}>{props.tag}</option>
                            </select> */}
                            <Select options={options} components={animatedComponents} onChange={(e) => setSelectedOptions(e)} isMulti isClearable onKeyDown={(e) => handleEnter(e)}/>
                        </div>
                        <div className="flex flex-row items-center">
                            <hr className={"flex-grow border border-dark-blue/40 bg-dark-blue/40"} />
                            <h1 className="mx-4 font-bold text-xl">OR</h1>
                            <hr className={"flex-grow border border-dark-blue/40 bg-dark-blue/40"} />
                        </div>
                            <p>
                                Type in a new category to have more ease in sorting your images
                            </p>
                            <div className={"p-5 my-5 border border-dark-blue rounded-lg"}>
                                <label className="block mb-2 text-sm font-medium" htmlFor="emailAddress">New Category</label>
                                <input type="text" name="emailAddress" className="w-full rounded-lg text-dark-blue border border-dark-blue p-2" placeholder="Category"
                                            value={inputTag} onChange={(e) => setInputTag(e.target.value)} onKeyDown={(e) => handleEnter(e)}/>
                            </div>
                        <div className="flex flex-row justify-center gap-4">
                            <button onClick={() => editTagOnImage()} className="rounded w-1/2 mx-auto mt-6 mb-3 p-2 bg-yellow text-dark-blue shadow font-bold">
                                {tagLoading ?
                                        <svg aria-hidden="true" role="status" class="inline w-5 h-5 mr-3 mb-1 text-dark-blue animate-spin" viewBox="0 0 99 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#ffb02e"/>
                                            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"/>
                                        </svg>
                                    :
                                        null
                                }
                                Categorize
                            </button>
                            <button onClick={() => setOpen(false)} className="rounded w-1/2 mx-auto mt-6 mb-3 p-2 bg-dark-blue text-yellow shadow font-bold">Cancel</button>
                        </div>
                    </Modal>
                    <Modal open={openDescribeImage} onClose={() => setOpenDescribeImage(false)} center container={document.querySelector('.main-content')}>
                        <h2 className="text-2xl mb-5 font-bold">Image Description</h2>
                        <p style={{minWidth: '600px'}}>
                                        {imageDescriptionLoading ? 
                                            <svg aria-hidden="true" role="status" class="inline w-5 h-5 mr-3 mb-1 text-dark-blue animate-spin" viewBox="0 0 99 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#ffffff"/>
                                            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"/>
                                        </svg> 
                                        : 
                                            null
                                        }
                                        {/*
                                        <div className="dot-container">
                                            <span className="text">Generating</span>
                                            <span className="dot"></span>
                                            <span className="dot"></span>
                                            <span className="dot"></span>
                                        </div>
                                        */}
                                        {imageDescription}
                        </p>
                        <br></br>
                        <div className="w-full flex flex-row justify-center">
                            <button className={`me-3 ${imageDescriptionLoading ? 'opacity-60' : null}`} disabled={imageDescriptionLoading} title="Copy Description To Clipboard" onClick={() => copyDescriptionToClipboard(imageDescription,setClipboardMessage)}>
                                <CardCopyDescription alt={"Copy Description To Clipboard Icon"}/> 
                            </button>
                            <button className={`me-3 ${imageDescriptionLoading ? 'opacity-60' : null}`} disabled={imageDescriptionLoading} title="Save As Prompt"
                                    onClick={() => downloadDescriptionAsPromptFile(imageDescription, downloadName)}>
                                <CardSaveDescription alt={"Save As Prompt Icon"}/>
                            </button>
                            <button className={`me-3 ${imageDescriptionLoading ? 'opacity-60' : null}`} disabled={imageDescriptionLoading} title="Populate Prompt" onClick={() => handlePromptPopulation()}>
                                <CardPopulatePrompt alt={"Populate Prompt Icon"}/>
                            </button>
                            <span>{clipboardMessage}</span>
                        </div>
                    </Modal>
                    {zoomedImage ?
                        <div className={"modal-overlay absolute inset-0 z-50 flex flex-col justify-center place-items-center bg-dark-blue/40 backdrop-blur"}>
                                <FullImageViewer image={zoomedImage.image} seed={zoomedImage.seed} tag={zoomedImage.tag} id={zoomedImage.id} setTag={(newTag) => setTag(newTag)} closeImageViewer={() => setZoomedImage(null)}/>
                        </div>
                    :
                        null    
                    }
                </>
            }
        </>
    );
});
export default CollectionImage;
